<template>
	<div class="grid p-fluid">
        <Toast/>
        <!-- Aviso fijo mientras Contablus espera al SRI (ver service/sriPendingToast.js) -->
        <Toast group="sriPending"/>
        <div class="col-12">
			<div class="card" :style="{'background-color':this.cardBackgroundColor}">
                <div class="saleHeader">
                    <h2 class="saleTitle">{{ (this.sale.edoc === null) ? "Venta" : "Factura" }} - {{ this.$store.getters.defaultActivity.name }}</h2>
                    <div class="saleHeaderActions">
                        <Button
                            v-if="isAuthorized"
                            v-tooltip.bottom="showProfit ? 'Ocultar utilidad' : 'Ver utilidad por línea'"
                            icon="pi pi-chart-line"
                            :class="['p-button-rounded', showProfit ? 'p-button-warning' : 'p-button-outlined p-button-secondary']"
                            @click="showProfit = !showProfit"
                        />
                        <Button v-show="showNewButton" icon="pi pi-plus" class="newsale-button p-button-rounded p-button-success" @click="newSale"/>
                    </div>
                </div>
				<div class="p-fluid formgrid grid">
					<div class="field col-12">
                        <div class="grid formgrid" style="margin-top: 10px;">
                            <div class="col-12">
                                <div class="card">
                                    <h5>Datos del Cliente</h5>
                                    <Button icon="pi pi-search" v-if="this.sale.editable" class="p-button-rounded p-button-info mr-2 mb-2" style="position: absolute; top: 20px; right: 20px;" @click="showCustomerDialog"/>
                                    <div class="grid formgrid" style="margin-top: 10px;">
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="customerName">Razón Social</label>
                                            <!-- La mesa va delante del nombre, fuera del campo: el nombre es el del cliente (XML/RIDE) -->
                                            <div :class="{'p-inputgroup': this.sale.table}">
                                                <span v-if="this.sale.table" class="p-inputgroup-addon">{{ this.sale.table.name }}</span>
                                                <InputText autofocus v-model="this.sale.customer.name" id="customerName" type="text" :class="{'p-invalid': this.nameError}" @change="checkForm()" :disabled="!this.sale.editable"/>
                                            </div>
                                            <small class="p-invalid" v-if="this.nameError">Ingrese el nombre o razón social</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="customerId">Cédula/RUC/Pasaporte</label>
                                            <InputText v-model="this.sale.customer.identification" id="customerId" type="text" :class="{'p-invalid': this.identificationError}" @change="checkForm()" :disabled="!this.sale.editable" />
                                            <small class="p-invalid" v-if="this.identificationError">La cédula debe tener 10 dígitos y el RUC 13 dígitos</small>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="saleCreatedAt">Fecha de creación</label>
                                            <Calendar id="saleCreatedAt" v-model="this.sale.createdAt" :showTime="true" hourFormat="24" dateFormat="dd/mm/yy" :minDate="minCreatedAt" :maxDate="maxCreatedAt" :showIcon="canEditCreatedAt" :disabled="!canEditCreatedAt"/>
                                        </div>
                                    </div>
                                    <div class="grid formgrid">
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="customerEmail" style="margin-top: 15px;">Correo</label>
                                            <InputText v-model="this.sale.customer.email" id="customerEmail" type="email" :disabled="!this.sale.editable"/>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="customerPhone" style="margin-top: 15px;">Teléfono</label>
                                            <InputText v-model="this.sale.customer.phone" id="customerPhone" type="number" :disabled="!this.sale.editable"/>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-4 lg:mb-0">
                                            <label for="customerAddress" style="margin-top: 15px;">Dirección</label>
                                            <InputText v-model="this.sale.customer.address" id="customerAddress" type="text" :class="{'p-invalid': this.addressError}" @change="checkForm()" :disabled="!this.sale.editable"/>
                                            <small class="p-invalid" v-if="this.addressError">Ingrese una dirección</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid formgrid" style="margin-top: 20px;">
                            <div class="col-12">
                                <div class="card">
                                    <div class="productsHeader">
                                        <h5 class="productsTitle">Producto(s) / Servicio(s)</h5>
                                        <div class="productsHeaderActions">
                                            <Button
                                                v-if="isAuthorized && this.sale.id"
                                                v-tooltip.bottom="showItemCreatedAt ? 'Ocultar fecha por línea' : 'Ver fecha por línea'"
                                                icon="pi pi-clock"
                                                class="p-button-rounded"
                                                :style="showItemCreatedAt
                                                    ? { backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)', color: 'var(--primary-color-text)' }
                                                    : { backgroundColor: 'transparent', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }"
                                                @click="showItemCreatedAt = !showItemCreatedAt"
                                            />
                                            <Button icon="pi pi-th-large" v-if="this.sale.editable && this.$store.getters.business.businessType === 'restaurant'" class="p-button-rounded" :style="{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)', color: 'var(--primary-color-text)' }" @click="showProductMenuDialog"/>
                                            <Button icon="pi pi-search" v-if="this.sale.editable && this.$store.getters.business.businessType !== 'restaurant'" class="p-button-rounded" :style="{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)', color: 'var(--primary-color-text)' }" @click="showProductDialog"/>
                                        </div>
                                    </div>
                                    <DataTable :value="this.sale.items" editMode="cell" @cell-edit-complete="onAmountChanged" :scrollable="true" scrollHeight="1200px" scrollDirection="both" class="mt-3 editable-cells-table">
                                        <Column field="productId" header="Cód." :style="{width: '10%','min-width':'50px'}">
                                            <template #body="slotProps">
                                                {{ slotProps.data.code !== undefined && slotProps.data.code !== null ? slotProps.data.code : slotProps.data.productId  }}
                                            </template>
                                        </Column>
                                        <Column field="amount" header="Cant." :style="{width: '12.5%','min-width':'100px'}">
                                            <template #editor="{data, field}" v-if="this.sale.editable && this.$store.getters.business.businessType !== 'restaurant'">
                                                <InputText v-model="data[field]" type="number" autofocus :disabled="!this.sale.editable"/>
                                            </template>
                                        </Column>
                                        <Column field="product" header="Descr." :style="{width: '30%','min-width':'75px'}">
                                            <template #body="slotProps">
                                                <div style="display: flex; flex-direction: column; width: 100%;">
                                                    <span>{{ slotProps.data.product }}</span>
                                                    <small v-if="showItemCreatedAt" style="color: #888; margin-top: 4px;">
                                                        <i class="pi pi-clock" style="font-size: 0.75rem; margin-right: 4px;"></i>{{ formatItemCreatedAt(slotProps.data.createdAt) }}
                                                    </small>
                                                </div>
                                            </template>
                                        </Column>
                                        <Column field="readableTax" header="IVA" :style="{width: '10%','min-width':'50px'}"></Column>
                                        <Column field="unitPrice" header="Precio Unit." :style="{width: '12.5%','min-width':'50px'}">
                                            <template #body="slotProps">
                                                 {{ formatUnitPrice(slotProps.data.unitPrice) }}
                                            </template>
                                            <template #editor="{data}" v-if="this.sale.editable">
                                                <Dropdown v-model="data.unitPrice" :options="data.priceList" :disabled="!this.sale.editable"/>
                                            </template>
                                        </Column>
                                        <Column field="readableDiscount" header="Descto. %" :style="{width: '12.5%','min-width':'100px'}">
                                            <template #editor="{data, field}" v-if="this.sale.editable">
                                                <InputText v-model="data[field]" type="number" autofocus :disabled="!this.sale.editable" @change="onDiscountChanged(data)"/>
                                            </template>
                                        </Column>
                                        <Column field="totalPrice" header="Precio Final" :style="{width: '10%','min-width':'50px'}">
                                            <template #body="slotProps">
                                                {{(slotProps.data.totalPrice).toFixed(2)}}
                                            </template>
                                        </Column>
                                        <Column v-if="showProfit" header="Utilidad $" :style="{width: '10%','min-width':'80px'}">
                                            <template #body="slotProps">
                                                {{ formatItemProfit(slotProps.data) }}
                                            </template>
                                        </Column>
                                        <Column v-if="showProfit" header="Utilidad %" :style="{width: '10%','min-width':'80px'}">
                                            <template #body="slotProps">
                                                {{ formatItemMargin(slotProps.data) }}
                                            </template>
                                        </Column>
                                        <Column :exportable="false" style="width: 50px;">
                                            <template #body="item" v-if="this.sale.editable">
                                                <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"  @click="onItemDeleted(item)"/>
                                            </template>
                                        </Column>
                                    </DataTable>
                                    <small v-if="showProfit" style="display: block; margin-top: 6px; color: #888;">
                                        Utilidad calculada sobre la base neta (sin IVA), usando el costo histórico de cada línea. Las líneas marcadas con "—" no tienen costo registrado.
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="grid formgrid" style="margin-top: 20px;">
                            <div class="col-12">
                                <div class="card">
                                    <div class="p-fluid formgrid grid">
                                        <div class="field col-12 md:col-6">
                                            <h5 v-if="this.sale.editable || (this.sale.editable === false && this.sale.observations)">Observaciones</h5>
                                            <ObservationsField v-if="this.sale.editable || (this.sale.editable === false && this.sale.observations)" :disabled="!this.sale.editable" :maxLength="observationsMaxLength" v-model="this.sale.observations" style="margin-bottom: 10px;"/>
                                            <div class="paymentContainer">
                                                <div class="col-12 mb-2 lg:col-6 lg:mb-0">
                                                    <h5>Plazo <label v-if="this.sale.creditDays>0"><i class="dueDateLabel" :style="{'color' : (!this.sale.isPaid) ? 'red' : 'black'}">{{this.sale.collectStatusReadable === "VENCIDA" ? 'Vencida' : 'Vence'}} el {{ this.sale.dueDateFormatted }}</i></label></h5>
                                                    <div class="paymentSubcontainer">
                                                        <div style="width: 100%;">
                                                            <Dropdown v-model="creditDay" :options="creditDays" optionLabel="name" @change="onCreditDaysChanged" placeholder="Días de plazo" :disabled="!this.sale.editable" />
                                                        </div>
                                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0 collectButton" v-if="!this.sale.editable && !this.sale.isPaid">
                                                            <Button :label="(this.sale.collectStatusReadable === 'COBRADA') ? 'Cobrado' : 'Cobrar'" :icon="(this.sale.collectStatusReadable === 'COBRADA') ? 'pi pi-check' : ''" :class="{'p-button-outlined': this.sale.collectStatusReadable === 'COBRADA', 'p-button-success': true, 'mr-2': true, 'mb-2': true}" :disabled="this.sale.collectStatusReadable === 'COBRADA'" @click="collectSale()" :loading="this.loadingCollectButton"/>
                                                            <Button label="Abonar" icon="pi pi-wallet" class="p-button-raised p-button-warning mr-2 mb-2" @click="abonarSale()"/>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                <h5 style="margin-bottom: 5px;">Pago</h5>
                                                <Dropdown v-model="this.sale.paymentMethod" :options="paymentMethods" optionLabel="name" placeholder="Forma de pago" :disabled="!this.sale.editable"/>
                                                <div v-if="!this.sale.editable && this.$store.getters.getUser.settings && this.$store.getters.getUser.settings.settings && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions.value" style="margin-top: 8px;">
                                                    <a @click="viewTransaction" style="cursor: pointer; color: #18407f; text-decoration: underline; font-size: 0.9rem;">
                                                        Ver transacción
                                                    </a>
                                                    <i v-if="loadingTransaction" class="pi pi-spin pi-spinner" style="margin-left: 8px; font-size: 0.9rem; color: #f18700;"></i>
                                                </div>
                                                <!-- El historial de abonos sigue accesible aunque la venta ya quedó
                                                     COBRADA y aunque haya contabilidad automática (H57). -->
                                                <div v-if="!this.sale.editable && hasPaymentHistory(this.sale)" style="margin-top: 8px;">
                                                    <a @click="paymentHistoryDialog = true" style="cursor: pointer; color: #18407f; text-decoration: underline; font-size: 0.9rem;">
                                                        Ver abonos ({{ this.sale.payments.length }})
                                                    </a>
                                                </div>
                                                <!-- Notas de crédito del cliente: su saldo a favor paga la venta. Se
                                                     canjean al cerrarla (Archivar/Facturar) o, si quedó pendiente,
                                                     como abono. No mueven caja: ese dinero ya se cobró. -->
                                                <div v-if="canUseCreditNotes" style="margin-top: 8px;">
                                                    <a @click="openCreditNoteDialog" style="cursor: pointer; color: #18407f; text-decoration: underline; font-size: 0.9rem;">
                                                        {{ this.sale.editable ? 'Pagar con nota de crédito' : 'Abonar con nota de crédito' }}
                                                    </a>
                                                    <i v-if="loadingCreditNotes" class="pi pi-spin pi-spinner" style="margin-left: 8px; font-size: 0.9rem; color: #f18700;"></i>
                                                    <div v-for="note in this.sale.creditNotesToRedeem" :key="note.id" class="flex align-items-center mt-1" style="font-size: 0.9rem;">
                                                        <i class="pi pi-ticket mr-2" style="color: #18407f;"></i>
                                                        <span>N/C {{ note.label }} · ${{ note.total.toFixed(2) }}</span>
                                                        <Button icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm p-button-danger ml-auto" @click="removeCreditNote(note)" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="this.sale.edoc !== null" style="margin-top: 10px;">
                                                <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                    <h5 style="margin: 5px 0px;">Secuencial</h5>
                                                    <h6 style="margin: 0px; font-weight: 300;">{{ this.sale.edoc.sequence }}</h6>
                                                </div>
                                                <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                    <h5 style="margin: 10px 0px 5px 0px;">Fecha Emisión</h5>
                                                    <label style="margin: 0px; font-weight: 300;">{{ (this.sale.createdAt) ? this.sale.createdAt.toLocaleDateString("es-ES") : "-" }}</label>
                                                </div>
                                                <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                    <h5 style="margin: 10px 0px 5px 0px;">Fecha Autorización</h5>
                                                    <label style="margin: 0px; font-weight: 300;">{{ (this.sale.edoc !== null && this.sale.edoc.authorizedAt !== null) ? this.sale.edoc.authorizedAt.toLocaleDateString("es-ES") : "-" }}</label>
                                                </div>
                                                <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                                    <h5 style="margin: 5px 0px;">Código de acceso</h5>
                                                    <h6 style="margin: 0px; font-weight: 300;">{{ this.sale.edoc.accessCode }}</h6>
                                                </div>
                                                <!-- Desenlace de la anulacion, no un cartel fijo: el texto y el color
                                                     salen de annulmentStatus (ver models/edocument.js). Antes decia
                                                     siempre "debe ser anulada en el portal del SRI" con solo mirar
                                                     nulled+received, y eso mentia justo cuando el SRI aceptaba la
                                                     solicitud. Lo que esta EN CURSO no sale aca. -->
                                                <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.sale.edoc !== null && this.sale.edoc.annulmentNotice !== null">
                                                    <div class="flex align-items-start mt-3 p-3"
                                                         :style="`background-color: var(--${this.sale.edoc.annulmentNotice.color}-50); border-left: 4px solid var(--${this.sale.edoc.annulmentNotice.color}-500); border-radius: 4px; --notice-accent: var(--${this.sale.edoc.annulmentNotice.color}-500); --notice-accent-strong: var(--${this.sale.edoc.annulmentNotice.color}-700);`">
                                                        <i class="pi mr-2 mt-1" :class="this.sale.edoc.annulmentNotice.icon"
                                                           :style="`color: var(--${this.sale.edoc.annulmentNotice.color}-700)`" />
                                                        <div style="flex: 1; min-width: 0;">
                                                            <div style="font-size: 0.9rem;">{{ this.sale.edoc.annulmentNotice.title }}</div>
                                                            <div v-if="this.sale.edoc.annulmentNotice.detail"
                                                                 style="font-size: 0.82rem; color: var(--text-color-secondary); margin-top: 0.15rem;">{{ this.sale.edoc.annulmentNotice.detail }}</div>
                                                            <Button v-if="this.sale.edoc.annulmentNotice.action"
                                                                    :label="this.sale.edoc.annulmentNotice.action.label"
                                                                    :icon="this.sale.edoc.annulmentNotice.action.icon"
                                                                    class="p-button-sm annulmentNoticeAction mt-2"
                                                                    :disabled="annulmentInProgress"
                                                                    @click="onAnnulmentAction(this.sale.edoc.annulmentNotice.action.name)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="field col-12 md:col-6 saleInformationContainer">
                                            <div style="display: flex;">
                                                <label>Subtotal 0%</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub0 ? this.sale.sub0.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>Subtotal 5%</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub5 ? this.sale.sub5.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>{{ this.sale.subGeneralLabel }}</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.subGeneral ? this.sale.subGeneral.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>Subtotal sin impuestos</label>
                                                <label style="margin: 0px 0px 0px auto;">
                                                    {{ (this.sale.sub0 && this.sale.sub12) ? this.sale.sub0.plus(this.sale.sub12).toFixed(2) : (this.sale.sub0 ? this.sale.sub0.toFixed(2) : (this.sale.sub12 ? this.sale.sub12.toFixed(2) : '0.00')) }}
                                                </label>
                                            </div>
                                            <div v-if="hasIce" style="display: flex;">
                                                <label>ICE</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.iceValue.toFixed(2) }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>IVA</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.tax ? this.sale.tax.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>Descuento</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.discount ? this.sale.discount.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div style="display: flex;">
                                                <label>Total</label>
                                                <label style="margin: 0px 0px 0px auto;">{{ this.sale.total ? this.sale.total.toFixed(2) : '0.00' }}</label>
                                            </div>
                                            <div v-if="this.sale.creditNotesToRedeem.length > 0" style="display: flex; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #ccc;">
                                                <label style="color: #18407f;">Nota(s) de crédito</label>
                                                <label style="margin: 0px 0px 0px auto; color: #18407f;">−{{ this.sale.creditNoteAmount.toFixed(2) }}</label>
                                            </div>
                                            <div v-if="this.sale.creditNotesToRedeem.length > 0" style="display: flex;">
                                                <label :style="{color: creditNoteRemainder < 0 ? '#c62828' : 'inherit'}"><b>Por cobrar</b></label>
                                                <label style="margin: 0px 0px 0px auto;" :style="{color: creditNoteRemainder < 0 ? '#c62828' : 'inherit'}"><b>{{ creditNoteRemainder.toFixed(2) }}</b></label>
                                            </div>
                                            <div v-if="this.sale.hasPartialPayments" style="display: flex; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #ccc;">
                                                <label style="color: #10b981;">Abonado</label>
                                                <label style="margin: 0px 0px 0px auto; color: #10b981;">{{ this.sale.paidAmount.toFixed(2) }}</label>
                                            </div>
                                            <div v-if="this.sale.hasPartialPayments" style="display: flex;">
                                                <label style="color: #f59e0b;"><b>Saldo pendiente</b></label>
                                                <label style="margin: 0px 0px 0px auto; color: #f59e0b;"><b>{{ this.sale.pendingAmount !== null ? this.sale.pendingAmount.toFixed(2) : this.sale.total.minus(this.sale.paidAmount).toFixed(2) }}</b></label>
                                            </div>
                                            <div v-if="showProfit" style="display: flex; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #ccc;">
                                                <label><b>Utilidad</b></label>
                                                <label style="margin: 0px 0px 0px auto;"><b>{{ formatTotalProfit() }} ({{ formatTotalMargin() }})</b></label>
                                            </div>
                                            <small v-if="hasIce" style="display: block; margin-top: 8px; color: #888;">
                                                El IVA se calcula sobre la base más el ICE
                                            </small>
                                        </div>
                                        <div class="field col-12 md:col-12 saleFormButtonContainer" style="margin-top: 35px;" v-if="this.nulled === false">
                                            <Button label="Limpiar" v-show="showClearButton" class="localButton p-button-raised p-button-danger mr-2 mb-2"  @click="clearSale"/>
                                            <Button label="Anular" v-show="showDeleteButton" class="localButton p-button-raised p-button-danger mr-2 mb-2"  @click="displayDeleteSaleConfirmation(true)"/>
                                            <div style="margin-left: auto;"></div>
                                            <Button label="Guardar" v-show="showSaveButton" :loading="loadingSaveButton" class="localButton p-button-raised p-button-secondary mr-2 mb-2"  @click="saveSale(false, true)"/>
                                            <Button label="Archivar" v-show="showArchiveButton" :loading="loadingArchiveButton" class="localButton p-button-raised p-button-primary mr-2 mb-2"  @click="saveSale(false, false)"/>
                                            <Button label="Facturar" v-show="showReceiptButton" :loading="loadingReceiptButton" class="localButton p-button-raised p-button-success mr-2 mb-2"  @click="saveSale(true, false)" />
                                            <Button label="Imprimir" v-show="showPrintButton" :loading="loadingPrintButton" class="localButton p-button-raised p-button-success mr-2 mb-2"  @click="printSale()" />
                                            <Menu ref="menu" :model="downloadOptions" :popup="true" class="localButton">
                                                <template #item="{item}">
                                                    <Button type="button" :label="item.label" :icon="item.icon" class="menuButton mr-2 mb-2" :loading="loadingDownloadReceiptButton" @click="downloadReceipt(item.name)"/>
                                                </template>
                                            </Menu>
                                            <Button type="button" label="Descargar" icon="pi pi-angle-down" v-show="showDownloadReceiptButton" class="localButton p-button-raised p-button-success mr-2 mb-2" @click="toggleDownloadMenu"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AccountEntry :data="this.sale" :isVisible="this.accountEntryDialog" :mode="this.accountEntryMode" transactionType="sale" @onSave="this.onSaveAccountEntry" @onCancel="this.onCancelAccountEntry"/>

                        <!-- Notas de crédito disponibles del cliente. Al cerrar la venta se
                             pueden elegir varias; como abono de una venta pendiente, una.
                             Cada una se usa entera. -->
                        <Dialog v-model:visible="creditNoteDialog" :header="'Notas de crédito de ' + (this.sale.customer ? this.sale.customer.name : '')" :style="{width: '520px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                            <div v-if="availableCreditNotes.length === 0" style="font-size: 0.95rem;">
                                El cliente no tiene notas de crédito disponibles. Solo se pueden usar las
                                autorizadas por el SRI, sin anular y que no se hayan canjeado antes.
                            </div>
                            <DataTable v-else :value="availableCreditNotes" v-model:selection="selectedCreditNotes" :selectionMode="this.sale.editable ? 'multiple' : 'single'" :metaKeySelection="false" dataKey="id" class="p-datatable-sm">
                                <Column :selectionMode="this.sale.editable ? 'multiple' : 'single'" headerStyle="width: 3rem"></Column>
                                <Column field="label" header="Nota de crédito"></Column>
                                <Column header="Fecha">
                                    <template #body="slotProps">{{ slotProps.data.createdAt.toLocaleDateString("es-ES") }}</template>
                                </Column>
                                <Column header="Saldo" style="text-align: right;">
                                    <template #body="slotProps">${{ slotProps.data.total.toFixed(2) }}</template>
                                </Column>
                            </DataTable>
                            <small v-if="availableCreditNotes.length > 0" style="display: block; margin-top: 10px; color: #666;">
                                Cada nota se usa entera: su valor no puede superar lo que falta cobrar de la venta.
                            </small>
                            <template #footer>
                                <Button label="Cancelar" class="p-button-secondary mr-2 mb-2" @click="creditNoteDialog = false" />
                                <Button v-if="availableCreditNotes.length > 0" :label="this.sale.editable ? 'Aplicar' : 'Abonar'" class="p-button-primary mr-2 mb-2" :loading="loadingCreditNotes" @click="confirmCreditNotes" />
                            </template>
                        </Dialog>

                        <PaymentHistoryDialog :payments="this.sale.payments" :isVisible="this.paymentHistoryDialog" @onClose="paymentHistoryDialog = false"/>

                        <Dialog header="Aviso" v-model:visible="receiptDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                            <p class="line-height-3 m-0">
                                {{ this.error.title }}<br>
                                {{ this.error.mensaje }}<br>
                                {{ this.error.informacionAdicional }}
                            </p>
                            <p v-if="businessAction && !canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                {{ businessActionHint(error.action) }}
                            </p>
                            <template #footer>
                                <Button label="Entendido" @click="closeReceiptDialog" icon="pi pi-check" class="p-button-outlined"/>
                                <Button v-if="businessAction && canEditBusiness" label="Ir a Negocio" icon="pi pi-external-link" @click="goToBusinessSection(error.action)" class="p-button-info"/>
                            </template>
                        </Dialog>

                        <Dialog header="Advertencia" v-model:visible="subscriptionDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                            <p class="line-height-3 m-0">
                                {{ this.error.title }}<br>
                                {{ this.error.mensaje }}<br>
                                {{ this.error.informacionAdicional }}
                            </p>
                            <template #footer>
                                <Button label="Cerrar" @click="closeSubscriptionDialog" class="p-button-secondary mr-2 mb-2"/>
                                <Button label="Ver suscripción" @click="redirectToSubscription" class="p-button-info mr-2 mb-2"/>
                            </template>
                        </Dialog>

                        <!-- Sin credenciales del portal no se le puede informar la
                             anulacion al SRI. Dos momentos distintos:
                               - Al ANULAR: se ofrece cargarlas, anular igual (dejando
                                 constancia de la divergencia) o cancelar.
                               - Al REPORTAR una anulacion que ya quedo solo aca
                                 ('unreported'): el unico camino es cargarlas. "Anular sin
                                 reportar" ya no tiene sentido —la venta YA esta anulada— y
                                 volver a dispararlo revierte stock y tesoreria otra vez. -->
                        <Dialog header="Credenciales del SRI no registradas" v-model:visible="showSriCredentialsDialog" :style="{width: '520px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                            <div class="flex align-items-start">
                                <i class="pi pi-info-circle mr-3 mt-1" style="font-size: 2rem; color: var(--blue-500)" />
                                <div v-if="annulmentUnreported">
                                    <p class="mb-2">
                                        Esta venta ya está anulada en Contablus, pero
                                        <strong>para el SRI el comprobante sigue vigente</strong>.
                                    </p>
                                    <p class="mb-0">
                                        Registra las credenciales del portal <strong>SRI en línea</strong>
                                        y Contablus se encargará de informar la anulación y de dar
                                        seguimiento al estado de la solicitud.
                                    </p>
                                    <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                        Pídele a un administrador que las registre en Negocio.
                                    </p>
                                </div>
                                <div v-else>
                                    <p class="mb-2">
                                        Para anular el comprobante ante el SRI de forma automática,
                                        el negocio necesita tener registradas sus credenciales del
                                        portal <strong>SRI en línea</strong>.
                                    </p>
                                    <p class="mb-0" style="font-size: 0.9rem; color: var(--orange-700);">
                                        Si continúas sin reportar, la venta quedará anulada en
                                        Contablus pero <strong>para el SRI el comprobante seguirá
                                        vigente</strong>. Tendrás que anularlo desde el portal o
                                        emitir una nota de crédito.
                                    </p>
                                    <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                        Pídele a un administrador que las registre en Negocio.
                                    </p>
                                </div>
                            </div>
                            <template #footer>
                                <Button :label="(annulmentUnreported && !canEditBusiness) ? 'Entendido' : 'Cancelar'" @click="showSriCredentialsDialog = false" class="p-button-secondary mr-2 mb-2"/>
                                <Button v-if="!annulmentUnreported" label="Anular sin reportar" icon="pi pi-exclamation-triangle" @click="deleteSale(false)" class="p-button-warning mr-2 mb-2"/>
                                <Button v-if="canEditBusiness" label="Registrar credenciales" icon="pi pi-external-link" @click="goToSriCredentials" class="p-button-info mr-2 mb-2" autofocus/>
                            </template>
                        </Dialog>

                        
                        <!-- Anular. Tres formas segun lo que reporte el backend en
                             `sale.annulment`: bloqueada (ya liquidada por la pasarela,
                             solo cabe Nota de Credito), con advertencias (ICE cobrado,
                             conciliacion sin confirmar) o confirmacion simple. -->
                        <!-- Desenlace de la anulacion. Dialog y no toast: los tres mensajes son
                             largos —el de "esperando al receptor" tiene que explicar que el
                             comprobante SIGUE VALIDO y hasta que fecha— y se desbordaban de la
                             pantalla. Es la comunicacion que cierra el flujo: el usuario tiene
                             que leerla, no alcanzarla de reojo antes de que se desvanezca. -->
                        <Dialog :header="annulmentOutcome ? annulmentOutcome.title : ''"
                                v-model:visible="showAnnulmentOutcome"
                                :style="{width: '460px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                            <div v-if="annulmentOutcome !== null" class="flex align-items-start">
                                <i class="pi mr-3" :class="annulmentOutcome.icon"
                                   :style="`font-size: 2rem; color: var(--${annulmentOutcome.color}-500)`" />
                                <!-- La clave de acceso son 49 digitos sin espacios: una "palabra" que el
                                     navegador no parte sola. `overflow-wrap: anywhere` la deja
                                     cortar, y `min-width: 0` es imprescindible porque como hijo
                                     de un flex su min-width:auto le impide encoger por debajo
                                     del ancho de su contenido. -->
                                <div style="min-width: 0;">
                                    <span style="line-height: 1.5; overflow-wrap: anywhere;">{{ annulmentOutcome.message }}</span>
                                    <p v-if="annulmentOutcome.action === 'sriCredentials' && !canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                        Pídele a un administrador que las registre en Negocio.
                                    </p>
                                </div>
                            </div>
                            <template #footer>
                                <Button label="Entendido" @click="showAnnulmentOutcome = false"
                                        class="p-button-secondary mr-2 mb-2" autofocus />
                                <!-- Sin credenciales la consulta inmediata no existe: el atajo lleva a
                                     cargarlas. El backend marca el motivo (reason), no se adivina. -->
                                <Button v-if="annulmentOutcome !== null && annulmentOutcome.action === 'sriCredentials' && canEditBusiness"
                                        label="Ir a Negocio" icon="pi pi-external-link" @click="goToSriCredentials"
                                        class="p-button-info mr-2 mb-2" />
                            </template>
                        </Dialog>
                        <Dialog :header="this.sale.canBeAnnulled ? 'Confirmación' : 'No se puede anular'" v-model:visible="showDeleteSaleConfirmation" :style="{width: this.sale.canBeAnnulled && this.sale.annulmentWarnings.length === 0 ? '350px' : '480px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                            <div v-if="!this.sale.canBeAnnulled">
                                <div class="flex align-items-start" v-for="blocker in this.sale.annulmentBlockers" :key="blocker.code">
                                    <i class="pi pi-ban mr-3" style="font-size: 2rem; color: var(--red-500)" />
                                    <span>{{ blocker.message }}</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="flex align-items-center">
                                    <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                                    <span>¿Está seguro de anular esta venta?</span>
                                </div>
                                <!-- Con factura autorizada hay que pedirle la anulación
                                     al SRI, y en notas de crédito y retenciones el receptor
                                     tiene que aceptarla. Decirlo ANTES evita que el usuario
                                     crea que el botón no funcionó. -->
                                <div v-if="this.sale.edoc !== null && this.sale.edoc.authorized === true" class="mt-3 p-3"
                                     style="background-color: var(--blue-50); border-left: 4px solid var(--blue-500); border-radius: 4px; font-size: 0.9rem;">
                                    Se enviará la solicitud al SRI. Puede tardar hasta un
                                    par de minutos y el resultado aparecerá en pantalla.
                                </div>
                                <div v-for="warning in this.sale.annulmentWarnings" :key="warning.code"
                                     class="flex align-items-start mt-3 p-3"
                                     style="background-color: var(--yellow-50); border-left: 4px solid var(--yellow-500); border-radius: 4px;">
                                    <i class="pi pi-exclamation-circle mr-2 mt-1" style="color: var(--yellow-700)" />
                                    <span style="font-size: 0.9rem;">{{ warning.message }}</span>
                                </div>
                            </div>
                            <template #footer>
                                <template v-if="this.sale.canBeAnnulled">
                                    <Button label="No" @click="displayDeleteSaleConfirmation(false)" class="p-button-secondary mr-2 mb-2"/>
                                    <Button label="Sí" @click="deleteSale" class="p-button-warning mr-2 mb-2" autofocus />
                                </template>
                                <template v-else>
                                    <Button label="Entendido" @click="displayDeleteSaleConfirmation(false)" class="p-button-secondary mr-2 mb-2" autofocus/>
                                    <Button label="Crear Nota de Crédito" icon="pi pi-file-edit" v-if="$can('creditNotes') && this.sale.edoc !== null && this.sale.allowsCreditNote" @click="goToCreditNote" class="p-button-info mr-2 mb-2"/>
                                </template>
                            </template>
                        </Dialog>

                        <Dialog header="Detalles de Transacciones" v-model:visible="transactionDialog" :breakpoints="{'960px': '90vw'}" :style="{width: '600px', 'background-color': '#ffffff'}" :modal="true" class="transaction-dialog">
                            <div v-if="transactionData && transactionData.length > 0" style="padding: 0.5rem;">
                                <!-- Resumen Total -->
                                <div class="transaction-card" style="background: linear-gradient(135deg, #18407f 0%, #27285c 100%); color: white; padding: 1.5rem; border-radius: 12px; margin-bottom: 1rem; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
                                    <div style="display: flex; align-items: center; margin-bottom: 0.75rem;">
                                        <i class="pi pi-receipt" style="font-size: 1.5rem; margin-right: 0.75rem;"></i>
                                        <span style="font-size: 0.9rem; opacity: 0.9;">Resumen de Pagos</span>
                                    </div>
                                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                                        <div>
                                            <div style="font-size: 0.85rem; opacity: 0.9; margin-bottom: 0.25rem;">Total Recibido</div>
                                            <div style="font-size: 1.5rem; font-weight: 700;">${{ calculateTotalAmount() }}</div>
                                        </div>
                                        <div>
                                            <div style="font-size: 0.85rem; opacity: 0.9; margin-bottom: 0.25rem;">Propina Total</div>
                                            <div style="font-size: 1.5rem; font-weight: 700;">${{ formatTransactionAmount(sale.tip) }}</div>
                                        </div>
                                    </div>
                                    <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid rgba(255,255,255,0.2); text-align: center;">
                                        <span style="font-size: 0.85rem; opacity: 0.9;">{{ transactionData.length }} {{ transactionData.length === 1 ? 'Transacción' : 'Transacciones' }}</span>
                                    </div>
                                </div>

                                <!-- Lista de Transacciones -->
                                <div style="max-height: 450px; overflow-y: auto; padding-right: 0.25rem;">
                                    <div v-for="(transaction, index) in transactionData" :key="index" class="transaction-card" style="background: white; padding: 1.25rem; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); margin-bottom: 1rem; border: 2px solid #eeedef;">
                                        <!-- Header de transacción -->
                                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; padding-bottom: 0.75rem; border-bottom: 2px solid #eeedef;">
                                            <div style="display: flex; align-items: center; min-width: 0;">
                                                <i :class="paymentMethodIcon(transaction.paymentMethod)" style="font-size: 1.2rem; margin-right: 0.5rem; color: #18407f;"></i>
                                                <div style="min-width: 0;">
                                                    <div style="font-weight: 600; color: #27285c; font-size: 1rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                        {{ transaction.account && transaction.account.name ? transaction.account.name : 'Cuenta' }}
                                                    </div>
                                                    <div style="font-size: 0.75rem; color: #6b7280;">
                                                        {{ paymentMethodLabel(transaction.paymentMethod) }}
                                                    </div>
                                                </div>
                                            </div>
                                            <span style="background: #18407f; color: white; padding: 0.25rem 0.75rem; border-radius: 12px; font-size: 0.75rem; font-weight: 600;">
                                                #{{ index + 1 }}
                                            </span>
                                        </div>

                                        <!-- Monto + Propina -->
                                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; margin-bottom: 1rem;">
                                            <div>
                                                <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;">Monto</div>
                                                <div style="font-size: 1.4rem; font-weight: 700; color: #f18700;">
                                                    ${{ formatTransactionAmount(transaction.amount) }}
                                                </div>
                                            </div>
                                            <div v-if="parseFloat(transaction.tip || 0) > 0">
                                                <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px;">Propina</div>
                                                <div style="font-size: 1.4rem; font-weight: 700; color: #18407f;">
                                                    ${{ formatTransactionAmount(transaction.tip) }}
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Metadata clave en filas (label : value) -->
                                        <div style="display: flex; flex-direction: column; gap: 0.4rem; font-size: 0.85rem;">
                                            <div v-if="transaction.reference" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-bookmark" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">Referencia:</span>
                                                <span style="color: #27285c; font-weight: 500; word-break: break-word;">{{ transaction.reference }}</span>
                                            </div>
                                            <div v-if="transaction.approvalNumber" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-check-circle" style="color: #16a34a; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">N° Aprobación:</span>
                                                <span style="color: #27285c; font-weight: 600;">{{ transaction.approvalNumber }}</span>
                                            </div>
                                            <div v-if="transaction.account && transaction.account.bank" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-building" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">{{ transaction.account.moneyType === 'CARD' ? 'Pasarela:' : 'Banco:' }}</span>
                                                <span style="color: #27285c; font-weight: 500;">{{ transaction.account.bank.name }}</span>
                                            </div>
                                            <div v-if="transaction.account && transaction.account.accountNumber" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-credit-card" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">N° Cuenta:</span>
                                                <span style="color: #27285c; font-weight: 500;">{{ transaction.account.accountNumber }}</span>
                                                <span v-if="transaction.account.accountType" style="color: #6b7280;">· {{ accountTypeLabel(transaction.account.accountType) }}</span>
                                            </div>
                                            <div v-if="transaction.createdAt" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-clock" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">Registrado:</span>
                                                <span style="color: #27285c;">{{ formatTransactionDate(transaction.createdAt) }}</span>
                                            </div>
                                            <div v-if="transaction.creator" style="display: flex; gap: 0.5rem;">
                                                <i class="pi pi-user" style="color: #6b7280; font-size: 0.9rem; margin-top: 2px;"></i>
                                                <span style="color: #6b7280; min-width: 110px;">Operador:</span>
                                                <span style="color: #27285c;">{{ transaction.creator }}</span>
                                            </div>
                                        </div>

                                        <!-- Liquidacion de la pasarela. Solo para cobros
                                             con tarjeta: son los unicos que la adquirente
                                             deposita en diferido. Sin `settlement` el cobro
                                             sigue en transito, no es que no aplique. -->
                                        <div v-if="isCardTransaction(transaction)" style="margin-top: 1rem; padding-top: 0.75rem; border-top: 1px dashed #eeedef;">
                                            <div v-if="transaction.settlement" style="background: #f0fdf4; border-left: 4px solid #16a34a; border-radius: 6px; padding: 0.75rem;">
                                                <div style="display: flex; align-items: center; margin-bottom: 0.5rem;">
                                                    <i class="pi pi-verified" style="color: #16a34a; margin-right: 0.5rem;"></i>
                                                    <span style="font-weight: 600; color: #15803d; font-size: 0.85rem;">
                                                        Liquidada el {{ transaction.settlement.date }}
                                                    </span>
                                                </div>
                                                <div style="display: flex; gap: 0.5rem; font-size: 0.85rem;">
                                                    <span style="color: #6b7280; min-width: 110px;">Neto acreditado:</span>
                                                    <span style="color: #27285c; font-weight: 600;">${{ formatTransactionAmount(transaction.settlement.net) }}</span>
                                                </div>
                                                <div v-if="settlementDeduction(transaction) !== null" style="display: flex; gap: 0.5rem; font-size: 0.85rem; margin-top: 0.25rem;">
                                                    <span style="color: #6b7280; min-width: 110px;">Retenido:</span>
                                                    <span style="color: #6b7280;">${{ settlementDeduction(transaction) }} en comisión y retenciones</span>
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; align-items: center; color: #6b7280; font-size: 0.85rem;">
                                                <i class="pi pi-clock" style="margin-right: 0.5rem;"></i>
                                                <span>En tránsito — la pasarela aún no deposita este cobro</span>
                                            </div>
                                        </div>

                                        <!-- Comprobante -->
                                        <div v-if="transaction.proof" style="margin-top: 1rem; padding-top: 0.75rem; border-top: 1px dashed #eeedef;">
                                            <div style="font-size: 0.7rem; color: #6b7280; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 0.5rem;">
                                                <i class="pi pi-paperclip" style="font-size: 0.8rem; margin-right: 0.25rem;"></i>
                                                Comprobante adjunto
                                            </div>
                                            <div v-if="isImageProof(transaction.proof)" style="position: relative; cursor: zoom-in;" @click="openProof(transaction.proof)">
                                                <img :src="resolveProofUrl(transaction.proof)" alt="Comprobante" style="width: 100%; max-height: 220px; object-fit: contain; border-radius: 8px; background: #f8f9fa; border: 1px solid #eeedef;" />
                                                <div style="position: absolute; top: 0.5rem; right: 0.5rem; background: rgba(0,0,0,0.55); color: white; padding: 0.2rem 0.5rem; border-radius: 6px; font-size: 0.7rem;">
                                                    <i class="pi pi-search-plus" style="font-size: 0.7rem; margin-right: 0.25rem;"></i>Ampliar
                                                </div>
                                            </div>
                                            <Button
                                                v-else
                                                label="Abrir comprobante"
                                                icon="pi pi-external-link"
                                                @click="openProof(transaction.proof)"
                                                class="p-button-raised p-button-sm"
                                                style="width: 100%; justify-content: center; padding: 0.5rem; font-weight: 600; font-size: 0.85rem; background: #18407f; border-color: #18407f;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template #footer>
                                <Button label="Cerrar" @click="transactionDialog = false" class="p-button-secondary" style="width: 100%;"/>
                            </template>
                        </Dialog>

                        <Dialog header="Sin transacción" v-model:visible="noTransactionDialog" :style="{width: '350px'}" :modal="true">
                            <div class="flex align-items-center justify-content-center">
                                <i class="pi pi-info-circle mr-3" style="font-size: 2rem; color: #18407f;" />
                                <span>No se encontró una transacción adjuntada a esta venta.</span>
                            </div>
                            <template #footer>
                                <Button label="Entendido" @click="noTransactionDialog = false" class="p-button-primary mr-2 mb-2" autofocus />
                            </template>
                        </Dialog>

                        <Dialog v-model:visible="customerDialog" :style="{'max-width': '450px', width: '90%'}" header="Buscar Cliente" :modal="true" class="p-fluid">
                            <Listbox autofocus :modelValue="selectedCustomer" :options="customerOptions" optionLabel="name" :filter="true" :filterFields="customerFilterFields" @filter="onCustomerFilterChanged" @change="onCustomerSelected"/>
                            <template #footer>
                                <Button label="Cerrar" class="p-button-secondary mr-2 mb-2" @click="hideCustomerDialog"/>
                            </template>
                        </Dialog>

                        <!-- Facturar una venta archivada a consumidor final: a nombre de quién va la
                             factura. Desde $50 el SRI pide los datos del cliente. -->
                        <Dialog v-model:visible="invoiceBuyerDialog" header="Facturar venta" :style="{width: '480px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                            <div v-if="!invoiceFinalAllowed" class="p-3 mb-3 flex align-items-center"
                                 style="gap: 0.5rem; background-color: var(--yellow-50); border-left: 4px solid var(--yellow-500); border-radius: 4px;">
                                <i class="pi pi-info-circle" style="color: var(--yellow-700)"></i>
                                <span style="font-size: 0.9rem;">Desde $50 el SRI pide los datos del cliente.</span>
                            </div>
                            <InvoiceBuyerForm v-model="invoiceBuyer" :total="saleTotalNumber" :findBuyer="findSaleBuyer" :limitHint="false"
                                              :errorField="invoiceBuyerError ? invoiceBuyerError.field : null" />
                            <small v-if="invoiceBuyerError" class="p-error" style="display: block; margin-top: 8px;">{{ invoiceBuyerError.message }}</small>
                            <template #footer>
                                <Button label="Cancelar" class="p-button-secondary mr-2 mb-2" @click="invoiceBuyerDialog = false" />
                                <Button :label="'Facturar $' + saleTotalNumber.toFixed(2)" class="p-button-success mr-2 mb-2" :loading="loadingReceiptButton" @click="invoiceArchived" />
                            </template>
                        </Dialog>

                        <Dialog v-model:visible="productDialog" :style="{'max-width': '600px', width: '90%'}" header="Buscar Producto" :modal="true" class="p-fluid">
                            <AutoComplete autofocus :placeholder="productSearchPlaceholder" id="dd" :dropdown="false" :multiple="false" v-model="searchedProduct" @complete="onProductFilterChanged($event)" inputStyle="width: 100%;" style="width: 100%; margin-top: 5px;" :selectOnFocus="true"/>
                            <DataTable :value="this.productOptions" v-model:selection="selectedProduct" selectionMode="single" @rowSelect="onProductSelected" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                <Column field="code" header="Cód." :style="{width: '25%','min-width':'70px'}"></Column>
                                <Column field="name" header="Nombre" :style="{width: '50%','min-width':'100px'}"></Column>
                                <Column field="stock" header="Stock" :style="{width: '10%','min-width':'60px'}">
                                    <template #body="slotProps">
                                        {{ (slotProps.data.stock !== undefined && slotProps.data.stock !== null) ? slotProps.data.stock.toFixed(2) : "-" }}
                                    </template>
                                </Column>
                                <Column field="price" header="Precio" :style="{width: '15%','min-width':'70px'}">
                                    <template #body="slotProps">
                                        ${{ formatUnitPrice(slotProps.data.price) }}
                                    </template>
                                </Column>
                            </DataTable>
                            <template #footer>
                                <Button label="Cerrar" class="p-button-secondary mr-2 mb-2" @click="hideProductDialog"/>
                            </template>
                        </Dialog>

                        <Dialog v-model:visible="productMenuDialog" :style="{'max-width': '900px', width: '90%'}" header="Seleccione productos" :modal="true" class="p-fluid" :dismissableMask="true">
                            <div class="col-12">
                                <div class="card">
                                    <DataView :key="dataViewKey" :value="this.productOptions" layout="grid" :paginator="true" :rows="9">
                                        <template #header>
                                            <div class="grid grid-nogutter">
                                                <AutoComplete :placeholder="productSearchPlaceholder" :dropdown="false" :multiple="false" v-model="searchedProduct" @complete="onProductFilterChanged($event)" inputStyle="width: 100%;" style="width: 100%; margin-top: 5px;" :selectOnFocus="true"/>
                                            </div>
                                        </template>
                                        <template #grid="slotProps">
                                            <div class="col-12 md:col-4">
                                                <div class="card m-3 border-1 surface-border">
                                                    <div class="flex align-items-center justify-content-between">
                                                        <div class="flex align-items-center">
                                                            <template v-if="slotProps.data.categoryName">
                                                                <i class="pi pi-tag mr-2"></i>
                                                                <span class="font-semibold">{{slotProps.data.categoryName}}</span>
                                                            </template>
                                                        </div>
                                                        <span v-if="slotProps.data.hasStock && this.isAuthorized" :class="'product-badge status-' + slotProps.data.stockBadge">{{ slotProps.data.stock }}</span>
                                                    </div>
                                                    <div class="text-center">
                                                        <img :src="(slotProps.data.imageUrl !== null) ? (this.$baseURL + slotProps.data.imageUrl) : ('../../images/product.png')" :alt="slotProps.data.name" class="w-9 shadow-2 my-3 mx-0"/>
                                                        <div class="text-2xl font-bold" >{{slotProps.data.name}}</div>
                                                        <div class="flex align-items-center justify-content-between" style="margin-top: 0.5rem;">
                                                            <Button icon="pi pi-minus" class="p-button-rounded p-button-info mr-2 mb-2" @click="onSelectedAmountChanged(slotProps.data, -1)"/>
                                                            <h4 style="margin-top: 0.2rem;">{{slotProps.data.selectedAmount}}</h4>
                                                            <Button icon="pi pi-plus" class="p-button-rounded p-button-info mr-2 mb-2" @click="onSelectedAmountChanged(slotProps.data, 1)"/>
                                                        </div>
                                                    </div>
                                                    <div class="flex align-items-center justify-content-between" style="margin-top: 0.5rem;">
                                                        <Menu ref="priceMenu" :model="slotProps.data.priceMap" :popup="true" style="width: 100px; background-color: lightgrey;">
                                                            <template #item="{item}">
                                                                <Button type="button" :label="item.label" class="menuButton mr-2 mb-2"/>
                                                            </template>
                                                        </Menu>
                                                        <span class="text-2xl font-semibold" @click="onPriceSelected">${{ (slotProps.data.price * slotProps.data.selectedAmount).toFixed(2) }}</span>
                                                        <Button :class="{ productSelected: slotProps.data.productSelected }" icon="pi pi-shopping-cart" @click="onProductSelected(slotProps)"></Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </DataView>
                                </div>
                            </div>
                            <template #footer>
                                <Button label="Cerrar" class="p-button-secondary mr-2 mb-2" @click="hideProductMenuDialog"/>
                            </template>
                        </Dialog>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

import { saveDownload } from '../../service/fileDownload';
import { authorizedXmlNotice } from '../../service/authorizedXml';
import Big from 'big.js';
import EventBus from '@/AppEventBus';
import { showSriPendingToast, clearSriPendingToast } from '@/service/sriPendingToast';
import httpRequest from '../../service/httpRequest';
import { printFeedback } from '../../service/printFeedback';
import { businessActionHint, certificateError } from '../../service/certificateError';
import { documentSavedDespiteReceiptError } from '../../service/receiptOutcome';
import { hasPaymentHistory } from '../../service/paymentHistory';
import { getScreenProfile } from '../../service/screenProfile';
import Sale, { OBSERVATIONS_MAX_LENGTH } from '../../models/sale';
import SaleItem from '../../models/saleItem';
import Customer from '../../models/customer';
import Business from '../../models/business';
import Product from '../../models/product';
import CreditNote from '../../models/creditNote';
import AccountEntry from '../../components/Accounting/AccountEntry.vue';
import { rejectionDetail, isAlreadyCollected, alreadyCollectedToast } from '../../components/Accounting/accountEntryRules';
import PaymentHistoryDialog from '../../components/Accounting/PaymentHistoryDialog.vue';
import ObservationsField from '../../components/General/ObservationsField.vue';
import InvoiceBuyerForm from '../../components/Restaurant/InvoiceBuyerForm.vue';
import { emptyBuyer, buyerError, buyerPayload, finalConsumerAllowed } from '../../service/restaurantPayment';

export default {
	data() {
		return {
            sale: new Sale(),
            screenProfile: {},   // Fase 5 (PRESENTED): documento de perfil del order-entry; {} = usar defaults
            cardBackgroundColor: "white",
            nulled: false,
            editable: true,
            customerOptions: [],
            customerFilterFields: ['name', 'identification', 'email'],
            selectedCustomer: null,
            customerDialog: false,
            // Facturar una archivada a consumidor final: a nombre de quién va la factura.
            invoiceBuyerDialog: false,
            invoiceBuyer: emptyBuyer(0),
            invoiceBuyerError: null,     // {field, message} de buyerError
            productOptions: [],
            selectedProduct: null,
            searchedProduct: null,
            productDialog: false,
            productMenuDialog: false,
            dataViewKey: 0,
            receiptDialog: false,
            subscriptionDialog: false,
            accountEntryDialog: false,
            accountEntryMode: 'simple', // 'simple' | 'multiple' | 'partial'
            paymentHistoryDialog: false,
            // Canje de notas de crédito del cliente (ver creditNoteDialog)
            creditNoteDialog: false,
            availableCreditNotes: [],
            selectedCreditNotes: [],
            loadingCreditNotes: false,
            pendingSale: null,
            error: {},
            nameError: false,
			identificationError: false,
			addressError: false,
            scannerBuffer: new String(),
            isAuthorized: true,

            // Show
            showNewButton: false,
            showClearButton: false,
            showSaveButton: false,
            showArchiveButton: false,
            showReceiptButton: false,
            showDeleteButton: false,
            showDeleteSaleConfirmation: false,
            showPrintButton: false,
            showDownloadReceiptButton: false,

            // Loading
            loadingSaveButton: false,
            loadingArchiveButton: false,
            loadingReceiptButton: false,
            loadingCollectButton: false,
            loadingPrintButton: false,
            loadingDownloadReceiptButton: false,
            
            creditDays: [
                {name: '0 días', code: '0'},
                {name: '1 días', code: '1'},
                {name: '3 días', code: '3'},
                {name: '7 días', code: '7'},
                {name: '14 días', code: '14'},
                {name: '21 días', code: '21'},
                {name: '30 días', code: '30'},
                {name: '45 días', code: '45'},
                {name: '60 días', code: '60'},
                {name: '90 días', code: '90'},
            ],
            creditDay: {name: '0 días', code: '0'},

            // Download
            downloadOptions: [],

            // Transaction
            loadingTransaction: false,
            transactionDialog: false,
            transactionData: null,
            noTransactionDialog: false,

            // Flag: solo true cuando el admin interactúa explícitamente con el Calendar.
            createdAtTouched: false,
            // Guard interno: ignora cambios del v-model hasta que PrimeVue Calendar
            // termine su normalización inicial (segundos/ms) tras el mount.
            canTrackCreatedAt: false,

            // Profit/Utility view (admin only). Siempre OFF al abrir el form.
            // Cuando se activa: se muestran columnas Utilidad $ y % por línea
            // y una fila de total en el resumen. El cálculo usa `item.cost`
            // (snapshot para items guardados, currentCost para nuevos).
            showProfit: false,

            // Mostrar columna "Fecha" (saleItem.createdAt) en la tabla de
            // productos. Por defecto OFF; se activa con el botón al lado de
            // "Buscar" en el contenedor de Productos/Servicios.
            showItemCreatedAt: false,

            // Anular una venta facturada ya no es instantáneo: hay que avisarle al
            // SRI y eso es un viaje por su portal. Mientras dura, se bloquea el
            // botón para no mandar dos solicitudes.
            annulmentInProgress: false,
            // Desenlace de la anulacion. Va en Dialog y no en toast: los mensajes
            // son largos (el de "esperando" explica el plazo y que el comprobante
            // sigue siendo valido) y se desbordaban de la pantalla. Ademas es
            // informacion que hay que leer, no que se pueda pasar de largo.
            showAnnulmentOutcome: false,
            annulmentOutcome: null,

            // Aviso cuando hay que anular un comprobante y el negocio no tiene
            // credenciales del portal del SRI cargadas.
            showSriCredentialsDialog: false,
		}
	},
    async created() {
        window.scrollTo(0, 0);

        // Setup accordingly to store setup
        this.isAuthorized = this.$can('salesManage');
        if (await this.$store.getters.business.businessType === 'restaurant') { this.fetchMenu(); }

        // Get sale
        let saleId = this.$route.query.id;
        if (saleId !== null && saleId !== undefined) {
            let response = await httpRequest.getSale(saleId);
            if (response.status == 200) {
                this.sale = new Sale(response.data);
                this.setupUI();
                // Setup duedate/creditdays dropdown
                this.creditDay = this.getCreditDayDic(this.sale.creditDays);
            }
        } else { this.setupUI(); }

        // Load sale from proforma
        let proformaId = this.$route.query.proformaId;
        if (proformaId !== null && proformaId !== undefined) { this.getProforma(proformaId) }
        
        // Register event listener for scanner
        document.addEventListener('keydown', this.onScanned);

        // Resultado de la anulación contra el SRI (llega por WebSocket).
        EventBus.on('annulment_result', this.onAnnulmentResult);

        // Fase 5 (capa PRESENTED): perfil de pantalla del order-entry (system→vertical→cuenta), ya
        // filtrado por entitlement. Solo ajusta la PRESENTACIÓN (hoy: el modo de búsqueda). Best-effort:
        // si falla, screenProfile queda {} y se usan los defaults del formulario.
        try {
            const profile = await getScreenProfile('order-entry');
            if (profile && profile.document) this.screenProfile = profile.document;
        } catch (e) { /* fallback: defaults */ }
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onScanned);
        EventBus.off('annulment_result', this.onAnnulmentResult);
        clearSriPendingToast(this.$toast);
    },
    watch: {
        // Cualquier cambio de sale.createdAt cuenta como interacción del usuario
        // SOLO si ya pasamos la fase de inicialización (PrimeVue Calendar normaliza
        // el v-model al montarse: descarta segundos/ms — eso no debe contar).
        'sale.createdAt'() {
            if (this.canTrackCreatedAt) {
                this.createdAtTouched = true;
            }
        },
        // Al corregir el comprador se va el error que se había marcado (como en Mesas).
        invoiceBuyer() {
            this.invoiceBuyerError = null;
        },
    },
    computed: {
        saleTotalNumber() {
            return this.sale && this.sale.total ? Number(this.sale.total.toString()) : 0;
        },
        invoiceFinalAllowed() {
            return finalConsumerAllowed(this.saleTotalNumber);
        },
        // El aviso del comprobante lleva a una sección de Negocio (firma o establecimientos).
        businessAction() {
            return !!this.error && (this.error.action === 'certificate' || this.error.action === 'establishments');
        },
        observationsMaxLength() {
            return OBSERVATIONS_MAX_LENGTH;
        },
        // Fase 5 (PRESENTED): placeholder del buscador de productos según el perfil de pantalla.
        // Verticales con búsqueda por código de barras (farmacia/retail/distribución) invitan a
        // escanear; el resto busca por nombre. Fallback al texto por nombre si no hay perfil.
        productSearchPlaceholder() {
            const search = this.screenProfile && this.screenProfile.search;
            if (search && search.primary === 'barcode') return 'Escanear o buscar por código...';
            return 'Buscar por nombre...';
        },
        // Sin credenciales del portal no se le puede informar la anulación al SRI.
        hasSriCredentials() {
            const business = this.$store.getters.business;
            return !!(business && business.hasSriPortalCredentials);
        },
        // Cargarlas vive en Negocio, que es pantalla de administrador: a un
        // operador no tiene sentido ofrecerle el atajo.
        canEditBusiness() {
            return this.$can('business');
        },
        // La venta ya se anulo en Contablus sin avisarle al SRI. Decide que
        // variante muestra el aviso de credenciales.
        annulmentUnreported() {
            return !!(this.sale && this.sale.edoc && this.sale.edoc.annulmentUnreported);
        },
        // La fila de ICE solo aparece si el documento lo lleva: a diferencia de
        // las tarifas de IVA (0% / 5% / general), que son buckets de la misma
        // base y se muestran siempre, el ICE es un impuesto aparte que la mayoría
        // de negocios nunca factura y en cero solo sería ruido.
        hasIce() {
            const ice = this.sale && this.sale.iceValue;
            return !!(ice && !ice.eq(0));
        },
        hasAccountability() {
            const user = this.$store.getters.getUser;
            const flag = user && user.settings && user.settings.settings && user.settings.settings.account_enableAutoTransactions;
            return !!(flag && flag.value);
        },
        // Las notas de crédito son saldo a favor de un cliente identificado: se
        // canjean al cerrar la venta, o como abono si ya quedó pendiente.
        canUseCreditNotes() {
            const customer = this.sale && this.sale.customer;
            if (!customer || customer.id === null || customer.id === undefined || customer.isConsumidorFinal) { return false }
            if (this.sale.editable) { return true }
            return !this.sale.isPaid && this.sale.collectStatus === 'PENDING';
        },
        // Lo que queda por cobrar con dinero después de las notas elegidas.
        creditNoteRemainder() {
            const total = this.sale && this.sale.total ? Number(this.sale.total.toString()) : 0;
            return Math.round((total - this.sale.creditNoteAmount) * 100) / 100;
        },
        canEditCreatedAt() {
            // Editable solo si el usuario es admin Y la venta sigue en estado "guardada" (editable=true).
            // Una vez archivada/facturada (editable=false) el campo se muestra pero queda bloqueado.
            return this.isAuthorized && this.sale.editable === true;
        },
        minCreatedAt() {
            const d = new Date();
            d.setDate(d.getDate() - 89);
            return d;
        },
        maxCreatedAt() {
            return new Date();
        },
        paymentMethods() {
            const baseMethods = [
                {name: 'Efectivo', code: 'CASH'},
                {name: 'Transferencia', code: 'TRANSFER'},
                {name: 'Tarjeta Débito', code: 'DEBIT_CARD'},
                {name: 'Tarjeta Crédito', code: 'CREDIT_CARD'},
                {name: 'Cheque', code: 'CHECK'},
            ];
            
            // Solo agregar MIXTO si la contabilidad automática está activada
            const user = this.$store.getters.getUser;
            const hasAccountability = user && user.settings && user.settings.settings && user.settings.settings.account_enableAutoTransactions && user.settings.settings.account_enableAutoTransactions.value;
            if (hasAccountability === true) {
                baseMethods.push({name: 'Mixto', code: 'MIXED'});
            }
            // Una venta pagada entera con notas de crédito lo lleva, pero no se
            // elige a mano: lo asigna el backend al canjearlas. Solo se agrega para
            // que la venta ya cerrada lo muestre.
            if (this.sale && this.sale.paymentMethod && this.sale.paymentMethod.code === 'CREDIT_NOTE') {
                baseMethods.push({name: 'Nota de crédito', code: 'CREDIT_NOTE'});
            }

            return baseMethods;
        }
    },
	methods: {
        hasPaymentHistory,
        // Construye el payload de venta aplicando la política de createdAt:
        // sólo se envía si el admin tocó explícitamente el Calendar. En cualquier
        // otro caso se omite para que el servidor asigne la fecha actual.
        buildSalePayload(paymentPlan = null) {
            const allowOverride = this.isAuthorized
                && this.createdAtTouched
                && (this.sale.createdAt instanceof Date);
            // Las notas de crédito se canjean solo al cerrar la venta; el plan de
            // pagos solo decide la forma de pago que va en la factura.
            const extra = {
                creditNotesToRedeem: undefined,
                creditNotes: this.sale.editable === false ? this.sale.creditNotesToRedeem.map(note => note.id) : [],
                payments: paymentPlan || undefined,
            };
            if (allowOverride) {
                return { ...this.sale, ...extra };
            }
            return { ...this.sale, ...extra, createdAt: undefined };
        },
        async onScanned(event) {
            var charCode = (typeof event.which === "number") ? event.which : event.key
            if (charCode !== 13) {
                this.scannerBuffer += String.fromCharCode(charCode);
            } else {
                let filter = this.scannerBuffer.replace('undefined', '');
                this.scannerBuffer = "";
                if (filter > 4) {
                    const result = await httpRequest.getProducts(filter, null, true, true);
                    if (result.status === 200 && result.data.length === 1) {
                        const product = new Product(result.data[0]);
                        this.onProductSelected({data: product});
                    }
                    return;
                }
            }
        },
        async setupUI() {
            // Reset del flag: al (re)cargar el form la fecha no fue tocada por el usuario.
            this.createdAtTouched = false;
            // Bloquear el watcher mientras PrimeVue Calendar normaliza el v-model inicial.
            this.canTrackCreatedAt = false;
            this.$nextTick(() => {
                this.$nextTick(() => { this.canTrackCreatedAt = true; });
            });

            if (this.sale.edoc !== null) { 
                this.nulled = this.sale.edoc.nulled;
                this.cardBackgroundColor = (this.sale.edoc.nulled === true) ? "#ffc9c9" : "white";
            } else {
                this.nulled = false;
                this.cardBackgroundColor = "white";
            }
        
            // Setup download options depending on sale type [Archived, Receipt]
            if (this.sale.edoc !== null) {
                this.downloadOptions = [
                    {
                        label: 'PDF',
                        name: 'pdf',
                        icon: 'pi pi-file-pdf'
                    },
                    {
                        label: 'XML',
                        name: 'xml',
                        icon: 'pi pi-file-excel'
                    },
                ];
            } else if (this.sale.id !== null) {
                this.downloadOptions = [
                    {
                        label: 'Nota de Venta',
                        name: 'sale_pdf',
                        icon: 'pi pi-file'
                    },
                ]
            }

            this.showNewButton = this.sale.id !== null;
            this.showClearButton = this.sale.id === null;
            this.showDeleteButton = this.sale.id !== null && this.isAuthorized;
            this.showSaveButton = this.sale.editable;
            this.showArchiveButton = this.sale.editable;
            this.showReceiptButton = this.sale.edoc === null && (await this.$store.getters.business.certName !== "Seleccionar");
            this.showPrintButton = (await this.$store.getters.hasDevices) && ((!this.sale.editable) || (await this.$store.getters.business.businessType === 'restaurant' && this.sale.id !== null));
            this.showDownloadReceiptButton = this.sale.id !== null;
            this.showDownloadXMLReceiptButton = this.sale.edoc !== null;
        },
        newSale() {
            let path = "/dashboard/venta/form"
            history.pushState(
                {},
                null,
                path
            )
            this.$router.go(path);
        },  
        formatItemCreatedAt(date) {
            if (!date) return '—';
            const d = (date instanceof Date) ? date : new Date(date);
            if (isNaN(d.getTime())) return '—';
            const pad = (n) => String(n).padStart(2, '0');
            const hh = pad(d.getHours());
            const mm = pad(d.getMinutes());
            const ss = pad(d.getSeconds());
            const DD = pad(d.getDate());
            const MM = pad(d.getMonth() + 1);
            const YY = pad(d.getFullYear() % 100);
            return `${hh}:${mm}:${ss} ${DD}/${MM}/${YY}`;
        },
        formatUnitPrice(price) {
            if (!price) return '0.00';
            // Convierte a string y separa decimales
            const str = price.toString();
            if (!str.includes('.')) return price.toFixed(2);
            const decimals = str.split('.')[1];
            // Si los últimos dos decimales no son ceros, muestra 4
            if (decimals.length > 2 && !/^0{2}$/.test(decimals.slice(-2))) {
                // Elimina ceros no significativos al final
                return parseFloat(price.toFixed(4)).toString();
            }
            // Si los últimos dos decimales son ceros, muestra solo 2
            return price.toFixed(2);
        },

        // ---- Utilidad (profit) ----
        // Base neta de la línea (sin IVA): unitPrice × (1 − discount) × amount.
        // Devuelve un Big o null si los datos son inválidos.
        getItemNetBase(item) {
            try {
                if (item === undefined || item === null) return null;
                if (item.unitPrice === undefined || item.amount === undefined) return null;
                const unitPrice = new Big(item.unitPrice);
                const amount = new Big(item.amount);
                const discount = item.discount !== undefined && item.discount !== null
                    ? new Big(item.discount) : new Big('0');
                return unitPrice.times(amount).times(new Big('1').minus(discount));
            } catch (e) { return null; }
        },
        // Costo total de la línea: cost × amount. Null si no hay costo.
        getItemLineCost(item) {
            try {
                if (item === undefined || item === null || item.cost === null || item.cost === undefined) return null;
                const cost = new Big(item.cost);
                const amount = new Big(item.amount);
                return cost.times(amount);
            } catch (e) { return null; }
        },
        getItemProfit(item) {
            const base = this.getItemNetBase(item);
            const cost = this.getItemLineCost(item);
            if (base === null || cost === null) return null;
            return base.minus(cost);
        },
        getItemMargin(item) {
            const profit = this.getItemProfit(item);
            const cost = this.getItemLineCost(item);
            if (profit === null || cost === null || cost.eq(0)) return null;
            return profit.div(cost).times(100);
        },
        formatItemProfit(item) {
            const profit = this.getItemProfit(item);
            return profit === null ? '—' : profit.toFixed(2);
        },
        formatItemMargin(item) {
            const margin = this.getItemMargin(item);
            return margin === null ? '—' : `${margin.toFixed(2)}%`;
        },
        // Totales: suman solo líneas con costo conocido. Si ninguna línea tiene
        // costo el total es null (muestra "—").
        getTotalProfit() {
            if (!this.sale || !this.sale.items || this.sale.items.length === 0) return null;
            let total = new Big('0');
            let anyKnown = false;
            for (const item of this.sale.items) {
                const profit = this.getItemProfit(item);
                if (profit !== null) {
                    total = total.plus(profit);
                    anyKnown = true;
                }
            }
            return anyKnown ? total : null;
        },
        getTotalCostKnown() {
            if (!this.sale || !this.sale.items || this.sale.items.length === 0) return null;
            let total = new Big('0');
            let anyKnown = false;
            for (const item of this.sale.items) {
                const cost = this.getItemLineCost(item);
                if (cost !== null) {
                    total = total.plus(cost);
                    anyKnown = true;
                }
            }
            return anyKnown ? total : null;
        },
        formatTotalProfit() {
            const total = this.getTotalProfit();
            return total === null ? '—' : total.toFixed(2);
        },
        formatTotalMargin() {
            const profit = this.getTotalProfit();
            const cost = this.getTotalCostKnown();
            if (profit === null || cost === null || cost.eq(0)) return '—';
            return `${profit.div(cost).times(100).toFixed(2)}%`;
        },

        // Proforma
        async getProforma(proformaId) {
            let response = await httpRequest.getProforma(proformaId);
            if (response.status == 200) {
                this.sale = new Sale(response.data);
                this.sale.loadFromProforma(response.data.id);
                this.setupUI();
                // Setup duedate/creditdays dropdown
                this.creditDay = this.getCreditDayDic(this.sale.creditDays);
            }
        },

        // Customer
        checkForm() {
			var error = false;
			if (this.sale.customer.name === null || this.sale.customer.name === undefined || this.sale.customer.name === "") {
				this.nameError = true;
				error = true;
			} else { this.nameError = false }
			if (this.sale.customer.identification === null || this.sale.customer.identification === undefined ) {
				this.identificationError = true;
				error = true;
			} else if (/^\d+$/.test(this.sale.customer.identification) && this.sale.customer.identification.length !== 10 && this.sale.customer.identification.length !== 13) {
				this.identificationError = true;
				error = true;
			} else { this.identificationError = false }
			if (this.sale.customer.address === null || this.sale.customer.address === undefined || this.sale.customer.address === "") {
				this.addressError = true;
				error = true;
			} else { this.addressError = false }
			return error;
		},
        showCustomerDialog() {
            this.customerDialog = true;
        },
        hideCustomerDialog() {
            this.customerDialog = false;
        },
        async onCustomerFilterChanged(event) {
            let filter = event.value;
            if (filter.length > 1) {
                const result = await httpRequest.getCustomers(filter);
                if (result.status === 200) {
                    this.customerOptions = result.data.map(customer => new Customer(customer));
                } else { this.customerOptions = [] }
            }
        },
        onCustomerSelected(event) {
            let customer = new Customer(event.value)
            this.sale.customer = customer;
            this.selectedCustomer = null;
            this.customerDialog = false;
        },

        // Product
        showProductDialog() {
            this.productDialog = true;
        },
        showProductMenuDialog() {
            this.productMenuDialog = true;
        },  
        hideProductDialog() {
            this.productDialog = false;
        },
        hideProductMenuDialog() {
            this.productMenuDialog = false;
        },
        async onProductFilterChanged(event) {
            let filter = event.query;
            if (filter.length > 1) {
                const result = await httpRequest.getProducts(filter, null, true, true);
                if (result.status === 200) {
                    // Create new products array
                    const newProducts = result.data.map(product => new Product(product));
                    // Update with a new key to force DataView re-render
                    this.productOptions = newProducts;
                    this.dataViewKey = Date.now();
                } else { 
                    this.productOptions = [];
                    this.dataViewKey = Date.now();
                }
            }
        },
        async fetchMenu() {
            const result = await httpRequest.getProducts(null, 'code', true, true);
            if (result.status === 200) {
                this.productOptions = result.data.map(product => new Product(product));
                this.dataViewKey = Date.now();
            } else { 
                this.productOptions = [];
                this.dataViewKey = Date.now();
            }
        },
        onProductSelected(data) {
            let product = new Product(data.data);
            let object = {
                productId: product.id,
                code: product.code,
                product: product.name,
                productObj: new Product(product),
                hasTax: product.hasTax,
                ivaCode: product.ivaCode,
                iceCode: product.iceCode,
                discount: product.discount,
                unitPrice: product.price,
                totalPrice: product.price,
                priceList: product.priceList,
                amount: product.selectedAmount,
                isPrintable: product.isPrintable,
                // Snapshot in-memory del costo FIFO actual del producto para
                // que la columna de utilidad funcione en items nuevos antes
                // de guardar la venta. El backend recalcula el snapshot
                // definitivo al crear el SaleItem.
                cost: product.currentCost,
            }
            
            let item = new SaleItem(object);
            this.sale.updateItems(item);
            
            this.selectedProduct = null;
            this.productDialog = false;

            // Animate selection
            data.data.selectedAmount = 1;
            data.data.productSelected = true;
            setTimeout(() => {
                data.data.productSelected = false
            }, 500)
        },
        onAmountChanged(event) {
            let item = new SaleItem(event.newData);
            this.sale.updateItems(item, false);
        },
        onSelectedAmountChanged(data, amount) {
            if (amount < 0 && data.selectedAmount == 1) { return }
            // Directly modify without triggering re-render
            data.selectedAmount += amount;
        },
        onSelectedPriceChanged(product, price) {
            product.price = price;
        },
        onPriceSelected(event) {
            this.$refs.priceMenu.toggle(event);
        },
        onItemDeleted(item) {
            this.sale.deleteItem(item.data);
        },
        onDiscountChanged(data) {
            data.discount = data.readableDiscount / 100;
            let item = new SaleItem(data);
            this.sale.updateItems(item, false);
        },

        // Sale
        clearSale() {
            this.sale = new Sale();
        },
        async saveSale(makeReceipt, editable) {
            // Una archivada a consumidor final tiene la tarjeta del cliente bloqueada: antes de
            // facturarla se pregunta a nombre de quién va (desde $50, el SRI pide los datos).
            if (makeReceipt && this.sale.asksInvoiceBuyer) {
                this.openInvoiceBuyer();
                return;
            }
            let result = this.checkForm();
            if (!result) {
                // Make SRI verification if making receipt
                if (makeReceipt && this.sale.total >= 50 && this.sale.customer.isConsumidorFinal) {
                    this.$toast.add({severity:'error', summary: 'Debe agregar un cliente', detail: 'Por reglamento del SRI las ventas mayores a 50 USD no pueden facturarse a nombre de CONSUMIDOR FINAL', life: 7000});
                    return;
                }

                if (this.sale.items === undefined || this.sale.items.length === 0) {
                    this.$toast.add({severity:'error', summary: 'Error guardando venta', detail: 'Agregue uno o mas productos', life: 3000});
                    return;
                }

                // Verificar si debe solicitar información de pago ANTES de guardar
                const hasAccountability = this.$store.getters.getUser.settings && this.$store.getters.getUser.settings.settings && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions.value;
                const isCurrentlyEditable = this.sale.editable; // Venta está en estado "GUARDADA"
                const isCreditSale = this.sale.creditDays > 0; // Venta con plazo (por cobrar)
                // Notas de crédito elegidas: se usan enteras, no pueden superar el
                // total. Si lo cubren todo no hay nada que cobrar con dinero.
                const hasCreditNotes = editable === false && this.sale.creditNotesToRedeem.length > 0;
                if (hasCreditNotes && this.creditNoteRemainder < 0) {
                    this.$toast.add({severity:'error', summary: 'Notas de crédito', detail: 'Las notas de crédito superan el total de la venta.', life: 5000});
                    return;
                }
                const coveredByCreditNotes = hasCreditNotes && this.creditNoteRemainder === 0;
                
                // Solo mostrar AccountEntry si:
                // 1. La contabilidad automática está activada
                // 2. La venta va a ser archivada o facturada (editable === false)
                // 3. La venta está actualmente en estado editable (no ha sido archivada previamente)
                // 4. Y NO es una venta a crédito (creditDays === 0, pago inmediato)
                if (hasAccountability === true && editable === false && isCurrentlyEditable === true && !isCreditSale && !coveredByCreditNotes) {
                    // Determinar el modo del AccountEntry según el método de pago
                    if (this.sale.paymentMethod.code === 'MIXED') {
                        this.accountEntryMode = 'multiple';
                    } else {
                        this.accountEntryMode = 'simple';
                    }
                    
                    // Guardar los parámetros para ejecutar después de AccountEntry
                    this.pendingSale = { makeReceipt, editable };
                    this.accountEntryDialog = true;
                    return; // Detener aquí, continuará en onSaveAccountEntry
                }

                // Si no requiere AccountEntry, proceder directamente
                await this.completeSaveProcess(makeReceipt, editable);
            }
        },
        async completeSaveProcess(makeReceipt, editable) {
            // Enable loading mode
            this.loadingSaveButton = editable === true;
            this.loadingArchiveButton = makeReceipt === false && editable === false ;
            this.loadingReceiptButton = makeReceipt === true;

            let isNewSale = this.sale.id === null;
            const before = { editable: this.sale.editable, paymentMethod: this.sale.paymentMethod };
            this.sale.editable = editable;
            this.sale.paymentMethod = this.sale.paymentMethod.code;

            // Construir payload aplicando la política de createdAt en un solo lugar.
            let payload = this.buildSalePayload();

            let response = await httpRequest.saveSale(payload, makeReceipt);

            // Disable loading mode
            this.loadingSaveButton = false;
            this.loadingArchiveButton = false;
            this.loadingReceiptButton = false;

            // Un 422 no guardó nada y su `data` es el campo a marcar ({field}), no la venta.
            if (response.status !== 422 && response.data !== undefined && response.data !== null) {
                this.sale = new Sale(response.data);
                this.setupUI();
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.sale.id
                )
            }
            if (response.status === 200) {
                if (this.sale.edoc !== null) {
                    if (this.sale.customer.email !== null) { // Response if e-receipt is sent to an email
                        this.$toast.add({severity:'success', summary: 'Factura enviada', detail: 'Su factura ha sido emitida y enviada exitosamente al correo: ' + this.sale.customer.email, life: 3000});
                    } else { // Default success e-receipt answer
                        this.$toast.add({severity:'success', summary: 'Factura emitida', detail: 'Su venta ha sido facturada', life: 3000});
                    }
                } else {
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su venta ha sido guardada', life: 3000});
                }
            } else if (response.status === 600 || response.status === 601) {
                this.error = response.error;
                this.error.title = "Su venta ha sido guardada éxitosamente, pero hemos tenido los siguientes problemas generar su factura:";
                this.receiptDialog = true;
            }  else if (response.status === 602 || response.status === 604) {
                this.error = certificateError(response, isNewSale);
                this.receiptDialog = true;
            } else if (response.status === 603) {
                this.$toast.add({severity:'warn', summary: 'Servicio del SRI no disponible', detail:'Su factura ha sido generada con éxito, y podrá reportar su factura al SRI cuando el servicio este activo nuevamente.', life: 10000});
            } else if (response.status === 802) {
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Su venta ha sido guardada por el momento. Para facturar por favor renueve su suscripción."
                this.subscriptionDialog = true;
            } else if (response.status === 422 && response.error) {
                // El backend dice por qué no se guardó (p. ej. una proforma vencida, o una factura
                // de una venta de hace 90 días o más) y la venta vuelve a como estaba.
                this.onSaveRefused(response, makeReceipt, before);
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }
            return response;
        },
        // Una regla del servidor frenó el guardado (422) y no quedó nada guardado: por ejemplo, una
        // venta de hace más de 90 días ya no se factura (R-3). Se dice con su mensaje y el formulario
        // vuelve a como estaba antes de enviar, con lo que el usuario venía editando.
        onSaveRefused(response, makeReceipt, before) {
            this.sale.editable = before.editable;
            this.sale.paymentMethod = before.paymentMethod;
            this.$toast.add({severity:'warn', summary: makeReceipt ? 'No se puede facturar' : 'No se guardó la venta', detail: response.error, life: 12000});
        },
        // Facturar una archivada a consumidor final (o a la etiqueta de una mesa): el diálogo elige
        // consumidor final o los datos del cliente; desde $50 solo los datos (SRI). El servidor le
        // asigna a la venta el cliente que llega (fiscal.settleInvoiceBuyer).
        openInvoiceBuyer() {
            this.invoiceBuyer = emptyBuyer(this.saleTotalNumber);
            this.invoiceBuyerError = null;
            this.invoiceBuyerDialog = true;
        },
        // Busca al cliente por su identificación exacta, como en Mesas pero con el buscador de
        // Clientes (`sales` requiere `customers`). Sin coincidencias el servidor responde
        // unknownError: es un cliente nuevo.
        async findSaleBuyer(identification) {
            const res = await httpRequest.getCustomers(identification);
            const found = res.status === 200 && Array.isArray(res.data)
                ? res.data.find(customer => customer.identification === identification) : null;
            return { status: 200, data: found || null };
        },
        async invoiceArchived() {
            const error = buyerError(this.invoiceBuyer, this.saleTotalNumber);
            this.invoiceBuyerError = error;
            if (error) { return }
            const buyer = buyerPayload(this.invoiceBuyer);
            const previous = this.sale.customer;
            // `saveSale` lee `phone` al crear la ficha y `phoneNumber` al actualizarla.
            this.sale.customer = buyer ? Object.assign(new Customer(buyer), { phoneNumber: buyer.phoneNumber }) : new Customer();
            const response = await this.completeSaveProcess(true, false);
            // Un 422 no guardó nada: la venta sigue a nombre de quien estaba.
            if (response.status === 422) { this.sale.customer = previous }
            this.invoiceBuyerDialog = false;
        },
        abonarSale() {
            // Abono (pago parcial): AccountEntry en modo 'partial' registra el
            // monto contra el endpoint registerPayment (ver onSaveAccountEntry).
            this.pendingSale = null;
            this.accountEntryMode = 'partial';
            this.accountEntryDialog = true;
        },
        async collectSale() {
            // Una venta con abonos previos ya no puede ir por el batch de
            // cobro completo (el backend exige Σ amount == total y su guardia
            // de idempotencia la rechazaría). "Cobrar" pasa a ser "abonar el
            // saldo completo": mismo endpoint, AccountEntry prellenado.
            if (this.sale.hasPartialPayments) {
                this.abonarSale();
                return;
            }

            const hasAccountability = this.$store.getters.getUser.settings && this.$store.getters.getUser.settings.settings && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions && this.$store.getters.getUser.settings.settings.account_enableAutoTransactions.value;
            if (hasAccountability === true) {
                // Determinar el modo según el método de pago
                if (this.sale.paymentMethod.code === 'MIXED') {
                    this.accountEntryMode = 'multiple';
                } else {
                    this.accountEntryMode = 'simple';
                }
                this.accountEntryDialog = true;
            } else {
                let response = await httpRequest.collectSale(this.sale.id);
                if (response.status === 200 && response.data !== null) {
                    this.sale = new Sale(response.data);
                    this.setupUI();
                    this.$toast.add({severity:'success', summary: 'Venta cobrada', detail: 'Su venta ha sido marcada como cobrada', life: 3000});
                } else {
                    this.$toast.add({severity:'error', summary: 'Error cobrando venta', detail: 'Por favor intente nuevamente, si el error continua comuníquese con el proveedor.', life: 3000}); 
                }
            }
        },
        async deleteSale(reportToSri = true) {
            // Con comprobante autorizado y sin credenciales del portal no hay forma
            // de informarle la anulación al SRI. Se pregunta antes, en vez de fallar
            // con un error técnico o —peor— anular solo acá sin que el usuario se
            // entere de que para el SRI el comprobante sigue vigente. Uno que el SRI
            // no autorizó no existe para él: el backend lo anula acá y listo.
            if (reportToSri && this.sale.edoc !== null && this.sale.edoc.authorized === true && !(await this.refreshSriCredentials())) {
                this.showDeleteSaleConfirmation = false;
                this.showSriCredentialsDialog = true;
                return;
            }

            this.showSriCredentialsDialog = false;
            this.annulmentInProgress = true;
            let response = await httpRequest.deleteSale(this.sale.id, reportToSri);
            if (response.status === 200) {
                // Venta CON factura: el backend le avisa al SRI y responde
                // {async:true}. Nada se revirtió todavía —el comprobante sigue
                // siendo válido— y el desenlace llega por WebSocket.
                if (response.data !== null && response.data.async === true) {
                    showSriPendingToast(this.$toast, {summary: 'Anulación en curso', detail: response.data.message,
                        onTimeout: () => { this.annulmentInProgress = false; }});
                    this.showDeleteSaleConfirmation = false;
                    return;
                }
                this.annulmentInProgress = false;
                if (response.data !== null) {
                    this.sale = new Sale(response.data);
                    this.setupUI();
                } else {
                    this.$router.push('/dashboard/venta/crud');
                }
            } else if (response.status === 422 && response.error) {
                // Guarda del backend (venta ya liquidada por la pasarela). El
                // formulario ya la conoce por `sale.annulment`, pero puede haber
                // quedado obsoleta si la conciliación se confirmó mientras la
                // pantalla estaba abierta: el mensaje del servidor manda.
                this.$toast.add({severity:'warn', summary: 'No se puede anular', detail: response.error, life: 12000});
                // El rechazo puede traer algo que el servidor acaba de saber (que el SRI
                // sí autorizó la factura): se recarga para que el formulario lo muestre.
                let fresh = await httpRequest.getSale(this.sale.id);
                if (fresh.status === 200) { this.sale = new Sale(fresh.data); this.setupUI(); }
            } else {
               this.$toast.add({severity:'error', summary: 'Error anulando venta', detail: 'Por favor intente nuevamente, si el error continua comuníquese con el proveedor.', life: 3000});
            }
            this.annulmentInProgress = false;
            this.showDeleteSaleConfirmation = false;
        },
        // Una sola accion, la que el aviso declare. Asi el modelo decide QUE se
        // puede hacer en cada estado y la plantilla no repite esa logica.
        onAnnulmentAction(name) {
            if (name === 'report') { return this.reportAnnulmentToSri() }
            if (name === 'check') { return this.checkAnnulmentStatus() }
        },
        // Informa al SRI una anulacion que quedo solo en Contablus. Los efectos
        // locales ya corrieron al anular: esto solo cierra la divergencia.
        async reportAnnulmentToSri() {
            if (this.sale === null || this.sale.edoc === null) { return }
            if (!(await this.refreshSriCredentials())) { this.showSriCredentialsDialog = true; return }
            this.annulmentInProgress = true;
            let response = await httpRequest.reportAnnulmentToSri(this.sale.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Reportando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            this.$toast.add({severity:'error', summary: 'No se pudo reportar',
                detail: response.error || 'Intenta de nuevo en un momento.', life: 10000});
        },
        // El flag vive en el store, y el store NO se rehidrata entre pestañas: si
        // el usuario cargo las credenciales en la pestaña que abre
        // goToSriCredentials, esta sigue viendo el valor viejo y el aviso volveria
        // a salir en bucle. Antes de frenar se le pregunta al backend.
        async refreshSriCredentials() {
            if (this.hasSriCredentials) { return true }
            const response = await httpRequest.syncAccount();
            if (response.status === 200 && response.data && response.data.business) {
                await this.$store.dispatch('setBusiness', new Business(response.data.business));
            }
            return this.hasSriCredentials;
        },
        // Abre Negocio en otra pestaña y cierra el aviso: al volver, el usuario
        // reintenta la anulación y esta vez sí se le informa al SRI.
        goToSriCredentials() {
            window.open('/dashboard/general/informacion-basica?focus=sri-portal', '_blank');
            this.showSriCredentialsDialog = false;
            this.showAnnulmentOutcome = false;
        },
        // La firma (602) o la dirección de un establecimiento (604) no dejan facturar: abre
        // Negocio en esa sección, en otra pestaña para no perder la venta; al volver, el
        // usuario reintenta «Facturar».
        goToBusinessSection(action) {
            window.open('/dashboard/general/informacion-basica?focus=' + action, '_blank');
            this.receiptDialog = false;
        },
        businessActionHint,
        // Desenlace de la anulacion, en Dialog (ver el comentario del template).
        // `action` (opcional) agrega un boton al dialogo; hoy solo 'sriCredentials'.
        setAnnulmentOutcome(title, icon, color, message, action = null) {
            this.annulmentOutcome = {title, icon, color, message, action};
            this.showAnnulmentOutcome = true;
        },
        // Desenlace de la anulación, por WebSocket. Tres finales posibles y hay que
        // distinguirlos: anulada, esperando al receptor (el comprobante SIGUE
        // VÁLIDO) o fallida.
        async onAnnulmentResult(data) {
            if (!data || this.sale === null || this.sale.edoc === null) { return }
            if (this.sale.edoc === undefined || data.edocId !== this.sale.edoc.id) { return }
            clearSriPendingToast(this.$toast);

            this.annulmentInProgress = false;
            if (data.status !== 'ok') {
                this.setAnnulmentOutcome('No se pudo anular', 'pi-times-circle', 'red', data.message);
            } else if (data.state === 'accepted') {
                this.setAnnulmentOutcome('Comprobante anulado', 'pi-check-circle', 'green', data.message);
            } else {
                // Pendiente: el receptor tiene 5 días hábiles y hasta entonces el
                // comprobante SIGUE SIENDO VÁLIDO. Es el desenlace que más hay que
                // leer, y justo el que no entraba en un toast.
                this.setAnnulmentOutcome('Esperando al receptor', 'pi-clock', 'orange', data.message);
            }

            // Se recarga para que el estado y el badge queden como los ve el backend.
            let response = await httpRequest.getSale(this.sale.id);
            if (response.status === 200) {
                this.sale = new Sale(response.data);
                this.setupUI();
            }
        },
        // Consulta manual: el flujo real es "te doy 24h para aceptar", así que el
        // usuario quiere verificar cuando el receptor le avisa, no al día siguiente.
        async checkAnnulmentStatus() {
            if (this.sale === null || this.sale.edoc === null) { return }
            this.annulmentInProgress = true;
            let response = await httpRequest.checkAnnulmentStatus(this.sale.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Consultando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            if (response.status === 200) {
                let sale = await httpRequest.getSale(this.sale.id);
                if (sale.status === 200) { this.sale = new Sale(sale.data); this.setupUI(); }
                // Mismo texto y misma longitud que el desenlace por WebSocket, asi
                // que mismo tratamiento: Dialog, no toast.
                this.setAnnulmentOutcome('Estado actualizado', 'pi-info-circle', 'blue',
                    this.sale.annulmentStateMessage || 'El comprobante ya no tiene una anulación en curso.');
            } else if (response.status === 422 && response.error) {
                // Respuesta del backend que hay que leer con calma (p. ej. sin
                // credenciales: desde cuando se confirmara solo). Dialog, no toast.
                const missingCredentials = !!(response.data && response.data.reason === 'sriCredentialsMissing');
                this.setAnnulmentOutcome('Consulta al SRI', 'pi-info-circle', 'blue', response.error,
                    missingCredentials ? 'sriCredentials' : null);
            } else {
                this.$toast.add({severity:'error', summary: 'No se pudo consultar',
                    detail: response.error || 'Intenta de nuevo en un momento.', life: 8000});
            }
        },
        // La liquidación solo existe para cobros con tarjeta: el resto entra
        // completo en el momento, sin diferido de la adquirente.
        isCardTransaction(transaction) {
            return !!(transaction && transaction.account && transaction.account.moneyType === 'CARD');
        },
        // Lo que la adquirente se quedó: bruto cargado (monto + propina, que al
        // plástico se le cobra junto) menos el neto depositado. Sale por residuo
        // igual que en el backend, porque cada marca deduce distinto.
        settlementDeduction(transaction) {
            if (!transaction || !transaction.settlement || transaction.settlement.net === null) { return null; }
            const gross = parseFloat(transaction.amount || 0) + parseFloat(transaction.tip || 0);
            const net = parseFloat(transaction.settlement.net);
            if (isNaN(gross) || isNaN(net)) { return null; }
            const deduction = gross - net;
            return deduction > 0 ? deduction.toFixed(2) : null;
        },
        // Nota de Crédito: la vía correcta para revertir una venta ya liquidada,
        // donde el dinero de la pasarela ya entró y anular descuadraría.
        goToCreditNote() {
            this.showDeleteSaleConfirmation = false;
            this.$router.push('/dashboard/nota-credito/form?saleId=' + this.sale.id);
        },
        // Canje de notas de crédito ------------------------------------------
        async openCreditNoteDialog() {
            this.loadingCreditNotes = true;
            const response = await httpRequest.getAvailableCreditNotes(this.sale.customer.id);
            this.loadingCreditNotes = false;
            if (response.status !== 200) {
                this.$toast.add({severity:'error', summary: 'Notas de crédito', detail: 'No se pudieron consultar las notas de crédito del cliente.', life: 4000});
                return;
            }
            this.availableCreditNotes = (response.data || []).map(note => new CreditNote(note));
            if (this.sale.editable) {
                const chosen = new Set(this.sale.creditNotesToRedeem.map(note => note.id));
                this.selectedCreditNotes = this.availableCreditNotes.filter(note => chosen.has(note.id));
            } else {
                this.selectedCreditNotes = null;
            }
            this.creditNoteDialog = true;
        },
        async confirmCreditNotes() {
            // Venta abierta: se eligen y se canjean al cerrarla (saveSale).
            if (this.sale.editable) {
                const notes = this.selectedCreditNotes || [];
                const amount = notes.reduce((sum, note) => sum + Number(note.total.toString()), 0);
                const total = this.sale.total ? Number(this.sale.total.toString()) : 0;
                if (Math.round((total - amount) * 100) < 0) {
                    this.$toast.add({severity:'warn', summary: 'Notas de crédito', detail: `Las notas suman $${amount.toFixed(2)} y la venta $${total.toFixed(2)}. Cada nota se usa entera: agrega productos o elige menos notas.`, life: 7000});
                    return;
                }
                this.sale.creditNotesToRedeem = notes;
                this.creditNoteDialog = false;
                return;
            }
            // Venta ya cerrada y pendiente: la nota se canjea como abono en el acto.
            const note = this.selectedCreditNotes;
            if (!note) { return }
            this.loadingCreditNotes = true;
            const response = await httpRequest.registerPayment({saleId: this.sale.id, creditNoteId: note.id});
            this.loadingCreditNotes = false;
            if (response.status === 200 && response.data) {
                this.creditNoteDialog = false;
                this.sale = new Sale(response.data);
                this.setupUI();
                this.$toast.add({severity:'success', summary: 'Nota de crédito aplicada', detail: this.sale.isPaid ? 'La nota completó el total y la venta quedó cobrada' : `Saldo pendiente: $${this.sale.pendingAmount !== null ? this.sale.pendingAmount.toFixed(2) : '-'}`, life: 4000});
            } else if (isAlreadyCollected(response)) {
                this.creditNoteDialog = false;
                await this.onAlreadyCollected(response);
            } else {
                this.$toast.add({severity:'error', summary: 'No se pudo aplicar', detail: response.error || 'Intenta de nuevo en un momento.', life: 7000});
            }
        },
        removeCreditNote(note) {
            this.sale.creditNotesToRedeem = this.sale.creditNotesToRedeem.filter(item => item.id !== note.id);
        },
        onCreditDaysChanged() {
            this.sale.creditDays = parseInt(this.creditDay.code);
        },
        getCreditDayDic(creditDays) {
            for (var i in this.creditDays) {
                if (this.creditDays[i].code == creditDays) { return this.creditDays[i]; }  
            }
            return this.creditDays[0];
        },
        displayDeleteSaleConfirmation(show) {
            this.showDeleteSaleConfirmation = show;
        },
        formatTransactionAmount(value) {
            if (value === null || value === undefined) {
                return '0.00';
            }
            const num = typeof value === 'number' ? value : parseFloat(value);
            if (isNaN(num)) {
                return '0.00';
            }
            return num.toFixed(2);
        },
        formatTransactionDate(value) {
            if (!value) return '';
            const d = new Date(value);
            if (isNaN(d.getTime())) return value;
            return d.toLocaleString('es-EC', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit',
            });
        },
        paymentMethodLabel(code) {
            const map = {
                CASH: 'Efectivo',
                TRANSFER: 'Transferencia',
                DEBIT_CARD: 'Tarjeta de Débito',
                CREDIT_CARD: 'Tarjeta de Crédito',
                CHECK: 'Cheque',
                MIXED: 'Mixto',
                CREDIT_NOTE: 'Nota de crédito',
            };
            return map[code] || 'Movimiento';
        },
        paymentMethodIcon(code) {
            const map = {
                CASH: 'pi pi-money-bill',
                TRANSFER: 'pi pi-send',
                DEBIT_CARD: 'pi pi-credit-card',
                CREDIT_CARD: 'pi pi-credit-card',
                CHECK: 'pi pi-file',
                MIXED: 'pi pi-th-large',
                CREDIT_NOTE: 'pi pi-ticket',
            };
            return map[code] || 'pi pi-wallet';
        },
        accountTypeLabel(code) {
            const map = { SAVING: 'Ahorros', CHECKING: 'Corriente' };
            return map[code] || code;
        },
        isImageProof(url) {
            if (!url || typeof url !== 'string') return false;
            return /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
        },
        resolveProofUrl(url) {
            if (!url || typeof url !== 'string') return url;
            if (/^(https?:)?\/\//i.test(url) || /^data:/i.test(url)) return url;
            const base = this.$baseURL || '';
            const baseTrim = base.replace(/\/$/, '');
            const path = url.startsWith('/') ? url : '/' + url;
            return baseTrim + path;
        },
        openProof(proofUrl) {
            const finalUrl = this.resolveProofUrl(proofUrl);
            if (finalUrl) {
                window.open(finalUrl, '_blank', 'noopener,noreferrer');
            }
        },
        calculateTotalAmount() {
            if (!this.transactionData || this.transactionData.length === 0) {
                return '0.00';
            }
            
            const total = this.transactionData.reduce((sum, transaction) => {
                const amount = typeof transaction.amount === 'number' ? transaction.amount : parseFloat(transaction.amount || 0);
                const tip = typeof transaction.tip === 'number' ? transaction.tip : parseFloat(transaction.tip || 0);
                return sum + amount + tip;
            }, 0);
            return total.toFixed(2);
        },
        async viewTransaction() {
            if (!this.sale.id) {
                this.noTransactionDialog = true;
                return;
            }
            
            this.loadingTransaction = true;
            try {
                const response = await httpRequest.getFinantialAccountTransaction(null, this.sale.id, null);
                if (response.status === 200 && response.data && Array.isArray(response.data) && response.data.length > 0) {
                    this.transactionData = response.data;
                    this.transactionDialog = true;
                } else {
                    this.noTransactionDialog = true;
                }
            } catch (error) {
                console.error("Error fetching transaction:", error);
                this.noTransactionDialog = true;
            } finally {
                this.loadingTransaction = false;
            }
        },
        closeReceiptDialog() {
            this.receiptDialog = false;
        },
        closeSubscriptionDialog() {
            this.subscriptionDialog = false;
        },
        redirectToSubscription() {
            this.subscriptionDialog = false;
            this.$router.push('/dashboard/general/suscripcion');
        },

        // Receipt
        toggleDownloadMenu(event) {
            this.$refs.menu.toggle(event);
        },
        async downloadReceipt(type) {
            if (type === 'pdf') {
                this.loadingDownloadReceiptButton = true;
                try {
                    const response = await httpRequest.downloadSaleEdoc(this.sale.edoc.id, type);
                    await saveDownload(response, "factura_" + this.sale.edoc.serial + ".pdf", "application/pdf", this.$toast);
                } finally {
                    this.loadingDownloadReceiptButton = false;
                }
            } else if (type === 'xml') {
                this.loadingDownloadXMLReceiptButton = true;
                try {
                    const response = await httpRequest.downloadSaleEdoc(this.sale.edoc.id, type);
                    if (await saveDownload(response, "factura_" + this.sale.edoc.serial + ".xml", "application/xml", this.$toast)) {
                        const notice = await authorizedXmlNotice(response);
                        if (notice) this.$toast.add(notice);
                    }
                } finally {
                    this.loadingDownloadXMLReceiptButton = false;
                }
            } else if (type === 'sale_pdf') {
                this.loadingDownloadXMLReceiptButton = true;
                try {
                    const response = await httpRequest.downloadSalePDF(this.sale.id, type);
                    const serial = String(this.sale.id).padStart(8, '0');
                    await saveDownload(response, "notaventa_" + serial + ".pdf", "application/pdf", this.$toast);
                } finally {
                    this.loadingDownloadXMLReceiptButton = false;
                }
            }
        },

        async printSale() {
            this.loadingPrintButton = true;
            const response = await httpRequest.printSale(this.sale.id);
            this.$toast.add(printFeedback(response));
            this.loadingPrintButton = false;
        },

        // Account Entry Delegate
        async onSaveAccountEntry(data) {
            this.accountEntryDialog = false;

            // Modo abono: registrar el pago parcial y refrescar la venta con
            // la respuesta (el backend marca PAID si el saldo llegó a cero).
            if (data.partial === true) {
                const response = await httpRequest.registerPayment({
                    saleId: this.sale.id,
                    amount: data.amount,
                    accountId: data.accountId,
                    paymentMethod: data.paymentMethod,
                    approvalNumber: data.approvalNumber,
                    proof: data.proof,
                });

                if (response.status === 200 && response.data) {
                    this.sale = new Sale(response.data);
                    this.setupUI();
                    if (this.sale.isPaid) {
                        this.$toast.add({severity:'success', summary: 'Venta cobrada', detail: 'El abono completó el total y la venta quedó cobrada', life: 4000});
                    } else {
                        this.$toast.add({severity:'success', summary: 'Abono registrado', detail: `Abono de $${data.amount.toFixed(2)} registrado. Saldo pendiente: $${this.sale.pendingAmount !== null ? this.sale.pendingAmount.toFixed(2) : '-'}`, life: 4000});
                    }
                } else if (isAlreadyCollected(response)) {
                    await this.onAlreadyCollected(response);
                } else if (response.status === 422 && response.error) {
                    this.$toast.add({severity:'error', summary: 'Abono rechazado', detail: response.error, life: 5000});
                } else {
                    this.$toast.add({severity:'error', summary: 'Error registrando abono', detail: 'Por favor intente nuevamente, si el error continua comuníquese con el proveedor.', life: 4000});
                }
                return;
            }

            // Determinar si es modo simple o múltiple
            const isMultipleMode = this.accountEntryMode === 'multiple';
            
            // Si NO hay venta pendiente, es collectSale (cobrar venta existente)
            if (this.pendingSale === null) {
                // El endpoint batch ahora marca la venta como PAID en backend
                // dentro de la misma transacción atómica que registra los
                // movimientos. Solo refrescamos la venta cuando el batch fue
                // exitoso; si falla, dejamos la venta en PENDING para que el
                // botón "Cobrar" siga visible y el usuario pueda reintentar.
                let batchSucceeded = false;

                if (isMultipleMode) {
                    // Modo múltiple: data = { transactions: [...], totalTip: X }
                    const { transactions, totalTip } = data;
                    
                    // Guardar propina total en el modelo Sale
                    if (totalTip && totalTip > 0) {
                        this.sale.tip = new Big(totalTip);
                    }
                    
                    // Preparar transacciones con referencias correctas
                    const preparedTransactions = transactions.map((transaction) => {
                        let reference;
                        if (this.sale.edoc !== null && this.sale.edoc !== undefined) {
                            reference = "FACTURA " + this.sale.edoc.sequence;
                        } else {
                            reference = "VENTA " + this.sale.id.toString().padStart(8, "0");
                        }
                        
                        // Agregar método de pago a la referencia
                        reference += " - " + transaction.paymentMethodName;
                        
                        // Agregar número de aprobación si existe
                        if (transaction.approvalNumber) {
                            reference += " - Aprobación: " + transaction.approvalNumber;
                        }
                        
                        return {
                            accountId: transaction.accountId,
                            amount: transaction.amount, // Positivo para ventas
                            reference: reference,
                            saleId: this.sale.id,
                            tip: transaction.tip || 0,
                            paymentMethod: transaction.paymentMethod,
                            approvalNumber: transaction.approvalNumber || null,
                            proof: transaction.proof || null
                        };
                    });
                    
                    // Crear todas las transacciones
                    const response = await httpRequest.createMultipleTransactions(preparedTransactions);
                    
                    if (response.status === 200) {
                        batchSucceeded = true;
                        this.sale.collectStatus = "PAID";
                        this.$toast.add({severity:'success', summary: 'Éxito', detail: `Se registraron ${preparedTransactions.length} pagos correctamente`, life: 3000});
                    } else if (isAlreadyCollected(response)) {
                        await this.onAlreadyCollected(response);
                    } else {
                        this.$toast.add({severity:'error', summary: 'Error', detail: rejectionDetail(response, 'No se pudieron registrar los pagos. Use el botón "Cobrar" para reintentar.'), life: 6000});
                    }
                } else {
                    // Modo simple: data = { accountId, accountName, amount, tip, approvalNumber, proof, paymentMethod }
                    const { accountId, amount, tip, approvalNumber, proof, paymentMethod } = data;
                    
                    // Guardar propina en el modelo Sale
                    if (tip && tip > 0) {
                        this.sale.tip = new Big(tip);
                    }
                    
                    // Construir referencia
                    let reference;
                    if (this.sale.edoc !== null && this.sale.edoc !== undefined) {
                        reference = "FACTURA " + this.sale.edoc.sequence;
                    } else {
                        reference = "VENTA " + this.sale.id.toString().padStart(8, "0");
                    }
                    
                    if (approvalNumber) {
                        reference += " - Aprobación: " + approvalNumber;
                    }
                    
                    // Crear la transacción vía el endpoint batch (1 item) para
                    // mantener un solo camino de persistencia.
                    const response = await httpRequest.createMultipleTransactions([{
                        accountId,
                        amount, // Positivo para ventas
                        reference,
                        saleId: this.sale.id,
                        tip: tip || 0,
                        paymentMethod: paymentMethod || null,
                        approvalNumber: approvalNumber || null,
                        proof: proof || null,
                    }]);
                    
                    if (response.status === 200) {
                        batchSucceeded = true;
                        this.sale.collectStatus = "PAID";
                        this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Nuevo ingreso de caja registrado', life: 3500});
                    } else if (isAlreadyCollected(response)) {
                        await this.onAlreadyCollected(response);
                    } else {
                        this.$toast.add({severity:'error', summary: 'Error', detail: rejectionDetail(response, 'No se pudo registrar la transacción. Use el botón "Cobrar" para reintentar.'), life: 6000});
                    }
                }

                // Solo refrescamos el modelo cuando el batch tuvo éxito; el
                // backend ya marcó la venta como PAID dentro del batch, por
                // lo que esta llamada actúa como refresco idempotente.
                if (batchSucceeded) {
                    let response = await httpRequest.collectSale(this.sale.id, this.sale.tip);
                    if (response.status === 200 && response.data !== null) {
                        this.sale = new Sale(response.data);
                        this.setupUI();
                    }
                }


                return;
            }
            
            // FLUJO CORRECTO: Guardar info de pago temporalmente
            const { makeReceipt, editable } = this.pendingSale;
            this.pendingSale = null; // Limpiar pendiente
            
            let capturedTransactionData = null;
            // Cómo se va a cobrar: el backend lo usa para la forma de pago de la
            // factura, que se arma ANTES de registrar los cobros.
            let paymentPlan = null;

            if (isMultipleMode) {
                // Modo múltiple: data = { transactions: [...], totalTip: X }
                const { transactions, totalTip } = data;
                
                // Guardar propina total en el modelo Sale
                if (totalTip && totalTip > 0) {
                    this.sale.tip = new Big(totalTip);
                }
                
                capturedTransactionData = { transactions, isMultiple: true };
                paymentPlan = transactions.map(t => ({paymentMethod: t.paymentMethod, amount: t.amount}));
            } else {
                // Modo simple: data = { accountId, accountName, amount, tip, approvalNumber, proof, paymentMethod }
                const { tip } = data;
                
                // Guardar propina en el modelo Sale
                if (tip && tip > 0) {
                    this.sale.tip = new Big(tip);
                }
            
                capturedTransactionData = { transactionData: data, isMultiple: false };
                paymentPlan = [{paymentMethod: data.paymentMethod || (this.sale.paymentMethod && this.sale.paymentMethod.code), amount: data.amount}];
            }

            // PASO 1: Guardar/Archivar/Facturar la venta primero
            this.loadingSaveButton = editable === true;
            this.loadingArchiveButton = makeReceipt === false && editable === false;
            this.loadingReceiptButton = makeReceipt === true;
            
            try {
                let isNewSale = this.sale.id === null;
                const before = { editable: this.sale.editable, paymentMethod: this.sale.paymentMethod };
                this.sale.editable = editable;
                this.sale.paymentMethod = this.sale.paymentMethod.code;
                const response = await httpRequest.saveSale(this.buildSalePayload(paymentPlan), makeReceipt);
                
                // Disable loading mode
                this.loadingSaveButton = false;
                this.loadingArchiveButton = false;
                this.loadingReceiptButton = false;
                
                // Un 422 no guardó nada y su `data` es el campo a marcar ({field}), no la venta.
                if (response.status !== 422 && response.data !== undefined && response.data !== null) {
                    this.sale = new Sale(response.data);
                    this.setupUI();
                    history.pushState(
                        {},
                        null,
                        this.$route.path + '?id=' + this.sale.id
                    );
                }
                
                // PASO 2: crear las transacciones. También cuando la venta quedó
                // guardada pero el comprobante falló (SRI, firma, cupo): la plata ya se
                // recibió y, si el cobro se descarta, la venta queda POR COBRAR para
                // siempre, porque al refacturar ya no se pide (H66).
                const receiptFailed = response.status !== 200;
                if (response.status === 200 || documentSavedDespiteReceiptError(response)) {
                    await this.registerCapturedSalePayments(capturedTransactionData, receiptFailed);
                }
                if (response.status === 600 || response.status === 601) {
                    this.error = response.error;
                    this.error.title = "Su venta ha sido guardada éxitosamente, pero hemos tenido los siguientes problemas generar su factura:";
                    this.receiptDialog = true;
                } else if (response.status === 602 || response.status === 604) {
                    this.error = certificateError(response, isNewSale);
                    this.receiptDialog = true;
                } else if (response.status === 603) {
                    this.$toast.add({severity:'warn', summary: 'Servicio del SRI no disponible', detail:'Su factura ha sido generada con éxito, y podrá reportar su factura al SRI cuando el servicio este activo nuevamente.', life: 10000});
                } else if (response.status === 802) {
                    this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                    this.error.mensaje = "Su venta ha sido guardada por el momento. Para facturar por favor renueve su suscripción.";
                    this.subscriptionDialog = true;
                } else if (response.status === 422 && response.error) {
                    // Nada se guardó ni se cobró: el cobro capturado se descarta con la venta.
                    this.onSaveRefused(response, makeReceipt, before);
                } else if (response.status !== 200) {
                    this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
                }
            } catch (err) {
                this.loadingSaveButton = false;
                this.loadingArchiveButton = false;
                this.loadingReceiptButton = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Error al procesar la venta', life: 3000});
            }
        },
        // Registra el cobro que AccountEntry capturó antes de guardar la venta. Corre
        // también cuando la venta quedó guardada pero el comprobante falló (H66):
        // entonces el aviso de éxito no habla de la factura.
        async registerCapturedSalePayments(capturedTransactionData, receiptFailed) {
            // Crear transacciones con la información real del documento
            if (capturedTransactionData.isMultiple) {
                // Modo múltiple: Preparar transacciones con la referencia correcta
                const preparedTransactions = capturedTransactionData.transactions.map((transaction) => {
                    let reference;
                    if (this.sale.edoc !== null && this.sale.edoc !== undefined) {
                        reference = "FACTURA " + this.sale.edoc.sequence;
                    } else {
                        reference = "VENTA " + this.sale.id.toString().padStart(8, "0");
                    }
                    
                    // Agregar método de pago a la referencia
                    reference += " - " + transaction.paymentMethodName;
                    
                    // Agregar número de aprobación si existe
                    if (transaction.approvalNumber) {
                        reference += " - Aprobación: " + transaction.approvalNumber;
                    }
                    
                    return {
                        accountId: transaction.accountId,
                        amount: transaction.amount, // Positivo para ventas
                        reference: reference,
                        saleId: this.sale.id,
                        tip: transaction.tip || 0,
                        paymentMethod: transaction.paymentMethod,
                        approvalNumber: transaction.approvalNumber || null,
                        proof: transaction.proof || null
                    };
                });
                
                // Crear todas las transacciones
                const transactionResponse = await httpRequest.createMultipleTransactions(preparedTransactions);
                
                if (transactionResponse.status === 200) {
                    // El batch backend ya marcó la venta como PAID;
                    // sincronizamos el estado local para que el UI
                    // refleje "Cobrada" sin tener que re-fetch.
                    this.sale.collectStatus = "PAID";
                    this.setupUI();
                    // Éxito en transacciones
                    if (receiptFailed) {
                        this.$toast.add({severity:'info', summary: 'Cobro registrado', detail: 'La venta quedó guardada y cobrada; el comprobante electrónico no se emitió.', life: 6000});
                    } else {
                        if (this.sale.edoc !== null) {
                            if (this.sale.customer.email !== null) {
                                this.$toast.add({severity:'success', summary: 'Factura enviada', detail: 'Su factura ha sido emitida y enviada exitosamente al correo: ' + this.sale.customer.email, life: 3000});
                            } else {
                                this.$toast.add({severity:'success', summary: 'Factura emitida', detail: `Su venta ha sido facturada y se registraron ${preparedTransactions.length} pagos`, life: 3000});
                            }
                        } else {
                            this.$toast.add({severity:'success', summary: 'Éxito', detail: `Su venta ha sido guardada y se registraron ${preparedTransactions.length} pagos`, life: 3000});
                        }
                    }
                } else if (isAlreadyCollected(transactionResponse)) {
                    await this.onAlreadyCollected(transactionResponse);
                } else {
                    // El batch falló: la venta quedó PENDING en
                    // backend. El usuario puede reintentar con el
                    // botón "Cobrar".
                    this.$toast.add({severity:'warn', summary: 'Advertencia', detail: rejectionDetail(transactionResponse, 'La venta se guardó pero hubo un error al registrar los pagos. Use el botón "Cobrar" para reintentar.'), life: 7000});
                }
            } else {
                // Modo simple
                const { accountId, amount, tip, approvalNumber, proof, paymentMethod } = capturedTransactionData.transactionData;
                
                // Construir referencia
                let reference;
                if (this.sale.edoc !== null && this.sale.edoc !== undefined) {
                    reference = "FACTURA " + this.sale.edoc.sequence;
                } else {
                    reference = "VENTA " + this.sale.id.toString().padStart(8, "0");
                }
                
                if (approvalNumber) {
                    reference += " - Aprobación: " + approvalNumber;
                }
                
                // Crear la transacción vía el endpoint batch (1 item).
                const transactionResponse = await httpRequest.createMultipleTransactions([{
                    accountId,
                    amount, // Positivo para ventas
                    reference,
                    saleId: this.sale.id,
                    tip: tip || 0,
                    paymentMethod: paymentMethod || null,
                    approvalNumber: approvalNumber || null,
                    proof: proof || null,
                }]);
                
                if (transactionResponse.status === 200) {
                    // El batch backend ya marcó la venta como PAID.
                    this.sale.collectStatus = "PAID";
                    this.setupUI();
                    // Éxito en transacción
                    if (receiptFailed) {
                        this.$toast.add({severity:'info', summary: 'Cobro registrado', detail: 'La venta quedó guardada y cobrada; el comprobante electrónico no se emitió.', life: 6000});
                    } else {
                        if (this.sale.edoc !== null) {
                            if (this.sale.customer.email !== null) {
                                this.$toast.add({severity:'success', summary: 'Factura enviada', detail: 'Su factura ha sido emitida y enviada exitosamente al correo: ' + this.sale.customer.email, life: 3000});
                            } else {
                                this.$toast.add({severity:'success', summary: 'Factura emitida', detail: 'Su venta ha sido facturada', life: 3000});
                            }
                        } else {
                            this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su venta ha sido guardada', life: 3000});
                        }
                    }
                } else if (isAlreadyCollected(transactionResponse)) {
                    await this.onAlreadyCollected(transactionResponse);
                } else {
                    // El batch falló: la venta quedó PENDING en
                    // backend. El usuario puede reintentar con el
                    // botón "Cobrar".
                    this.$toast.add({severity:'warn', summary: 'Advertencia', detail: rejectionDetail(transactionResponse, 'La venta se guardó pero hubo un error al registrar el pago. Use el botón "Cobrar" para reintentar.'), life: 7000});
                }
            }
        },
        // El cobro ya estaba registrado (910): doble clic, otra pestaña o un reintento después de
        // perder la respuesta. Se avisa y se recarga la venta como la ve el backend, sin invitar
        // a reintentar, que nunca funcionaría.
        async onAlreadyCollected(response) {
            this.$toast.add(alreadyCollectedToast(response, 'Esta venta ya fue cobrada'));
            const fresh = await httpRequest.getSale(this.sale.id);
            if (fresh.status === 200) {
                this.sale = new Sale(fresh.data);
                this.setupUI();
            }
        },
        onCancelAccountEntry() {
            this.accountEntryDialog = false;
            this.pendingSale = null; // Limpiar pendiente si el usuario cancela
            // Revertir los botones de loading si estaban activos
            this.loadingSaveButton = false;
            this.loadingArchiveButton = false;
            this.loadingReceiptButton = false;
        },
	},
    components: {
        'AccountEntry': AccountEntry,
        'PaymentHistoryDialog': PaymentHistoryDialog,
        'ObservationsField': ObservationsField,
        'InvoiceBuyerForm': InvoiceBuyerForm,
    },
}
</script>

<style scoped lang="scss">
/* Accion del aviso de anulacion.
   Dos correcciones sobre el default de PrimeVue en esta pantalla:
   - `width: auto` porque el formulario es `p-fluid` y estiraba el boton al 100%,
     lo que empujaba el icono a un extremo y el texto al otro.
   - Contorno en vez de `p-button-text`, que se leia como un enlace y no como
     algo que se pueda pulsar.
   El color sale de `--notice-accent`, que el aviso fija inline segun su estado,
   asi el boton vive en la misma tonalidad del panel en los cinco casos. */
.annulmentNoticeAction {
    width: auto;
    background: transparent;
    color: var(--notice-accent-strong);
    border: 1px solid var(--notice-accent);
    font-weight: 600;
}
.annulmentNoticeAction:enabled:hover,
.annulmentNoticeAction:enabled:focus {
    background: var(--notice-accent);
    border-color: var(--notice-accent);
    color: #fff;
    box-shadow: none;
}


@import '../../assets/demo/badges.scss';

    .menuButton {
        width: 100%;
        background-color: white;
        border: 0px;
        color: darkgrey;
    }
    .menuButton:hover {
        background-color: gray;
    }
    .newsale-button {
        /* Sin position:absolute: queda dentro del flujo flex del header */
        /* para evitar que se monte sobre los demás botones de acción.    */
    }
    .saleHeader {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
    }
    .saleTitle {
        font-size: large;
        margin: 0;
    }
    .saleHeaderActions {
        display: flex;
        gap: 8px;
        margin-left: auto;
    }
    .productsHeader {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
    }
    .productsTitle {
        margin: 0;
    }
    .productsHeaderActions {
        display: flex;
        gap: 8px;
        margin-left: auto;
    }
    @media (max-width: 600px) {
        .saleHeader {
            flex-direction: column-reverse;
            align-items: stretch;
            gap: 8px;
        }
        .saleHeaderActions {
            margin-left: 0;
            justify-content: flex-end;
        }
        .productsHeader {
            flex-direction: column-reverse;
            align-items: stretch;
            gap: 8px;
        }
        .productsHeaderActions {
            margin-left: 0;
            justify-content: flex-end;
        }
    }
    .p-menu {
        width: 40px;
    }
    .dueDateLabel {
        font-size: small;
        font-weight: 200;
    }
    .productSelected {
        background-color: green !important;
    }
    @media screen and (max-width: 769px) {
        .saleFormButtonContainer {
            display: block;
        }
        .paymentContainer {
            display: initial;
        }
        .paymentContainer > div > h5 {
            margin: 10px 0 5px 0; 
        }
        .paymentSubcontainer {
            display: block;
        }
        .collectButton {
            margin-top: 10px;
            padding: 0px;
            width: 100%;
        }
        .localButton {
            width: 100%
        }
        .saleform-title {
            font-size: small;
        }
    }
    @media screen and (min-width: 769px) {
        .saleFormButtonContainer {
            display: flex;
        }
        .saleInformationContainer {
            padding-left: 50px;
        }
        .paymentContainer {
            display: flex;
            margin-bottom: 5px;
        }
        .paymentContainer > div > h5 {
            margin-bottom: 5px; 
        }
        .paymentSubcontainer {
            display: flex;
        }
        .collectButton {
            margin-left: 10px;
            max-width: 150px;
        }
        .localButton {
            width: 170px
        }
        .saleform-title {
            font-size: large;
        }
    }

    // Estilos para el dialog de transacción
    .transaction-card {
        transition: all 0.3s ease;
    }

    .transaction-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
    }

    ::v-deep(.transaction-dialog) {
        .p-dialog-header {
            background: linear-gradient(135deg, #18407f 0%, #27285c 100%);
            color: white;
            border-radius: 12px 12px 0 0;
            padding: 1.5rem;
        }

        .p-dialog-content {
            padding: 1.5rem;
            background: #eeedef;
            
            /* Custom scrollbar */
            ::-webkit-scrollbar {
                width: 8px;
            }

            ::-webkit-scrollbar-track {
                background: #eeedef;
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb {
                background: #18407f;
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: #27285c;
            }
        }

        .p-dialog-footer {
            background: #eeedef;
            border-top: 1px solid #d1d5db;
            padding: 1rem 1.5rem;
        }
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .transaction-card {
        animation: fadeInUp 0.4s ease-out;
    }

</style>